// ============================================================
// Travel Rethinkways - Super Deals
// Converted from bundled JS to readable JSX
// ============================================================

import React, { memo } from "react";
import BookmarkIconButton from "./BookmarkIconButton";
import { makeBookmarkPost } from "../utils/bookmarkPost";
import assetUrl from "../utils/assetUrl";

// ─────────────────────────────────────────────────────────────
// IMAGE ASSET HELPERS
// Replace these paths with your actual image imports or URLs
// ─────────────────────────────────────────────────────────────

// Super Deal Destination images
const IMG_ANDAMAN = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Andaman.avif";
const IMG_AUSTRALIA_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Australia.avif";
const IMG_AZERBAIJAN_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Azerbaijan.avif";
const IMG_BALI_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Bali.avif";
const IMG_DELHI = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Delhi.avif";
const IMG_DUBAI_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Dubai.avif";
const IMG_EUROPE_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Europe.avif";
const IMG_GEORGIA_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Georgia.avif";
const IMG_HIMACHAL = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Himachal.avif";
const IMG_JAPAN_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Japan.avif";
const IMG_KARNATAKA = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Karnataka.avif";
const IMG_KASHMIR = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Kashmir.avif";
const IMG_KAZAKHSTAN_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Kazakhstan.avif";
const IMG_KERALA = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Kerala.avif";
const IMG_MALDIVES_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Maldives.avif";
const IMG_MEGHALAYA = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Meghalaya.avif";
const IMG_RAJASTHAN = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Rajasthan.avif";
const IMG_SOUTH_KOREA_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-South Korea.avif";
const IMG_SRI_LANKA_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Sri Lanka.avif";
const IMG_TAMIL_NADU = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Tamil Nadu.avif";
const IMG_THAILAND_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Thailand.avif";
const IMG_TURKEY_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Turkey.avif";
const IMG_VIETNAM_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Vietnam.avif";
const IMG_GOA = "/assets/images/attractions/Travel-Rethinkways-SuperDeals-goa.avif";
const IMG_MALAYSIA_DEST = "/assets/images/attractions/Travel-Rethinkways-SuperDealsMAlaysia.avif";

// Attraction images
const IMG_ATTRACTIONS = {
  "Travel-Rethinkways-SuperDeals-Australia-sydney-opera-house.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Australia-sydney-opera-house.avif",
  "Travel-Rethinkways-SuperDeals-Azerbaijan-Baku-Old-City.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Azerbaijan-Baku-Old-City.avif",
  "Travel-Rethinkways-SuperDeals-Azerbaijan-MudVolcanoes.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Azerbaijan-MudVolcanoes.avif",
  "Travel-Rethinkways-SuperDeals-Bali- Fire-Dance.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Bali- Fire-Dance.avif",
  "Travel-Rethinkways-SuperDeals-Bali-ATV-Ride.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Bali-ATV-Ride.avif",
  "Travel-Rethinkways-SuperDeals-Bali-Garuda-Wisnu-Kencana-Cultural-Park.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Bali-Garuda-Wisnu-Kencana-Cultural-Park.avif",
  "Travel-Rethinkways-SuperDeals-Bali-Lovina-Dolphin.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Bali-Lovina-Dolphin.avif",
  "Travel-Rethinkways-SuperDeals-Bali-Mount-Batur-Sunrise.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Bali-Mount-Batur-Sunrise.avif",
  "Travel-Rethinkways-SuperDeals-Bali-Safari-Park.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Bali-Safari-Park.avif",
  "Travel-Rethinkways-SuperDeals-Bali-Snorkeling-Experience.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Bali-Snorkeling-Experience.avif",
  "Travel-Rethinkways-SuperDeals-Bali-Waterbom-Bali.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Bali-Waterbom-Bali.avif",
  "Travel-Rethinkways-SuperDeals-Dubai-Burj-Khalifa.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Dubai-Burj-Khalifa.avif",
  "Travel-Rethinkways-SuperDeals-Dubai-Marina-Dhow-Cruise.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Dubai-Marina-Dhow-Cruise.avif",
  "Travel-Rethinkways-SuperDeals-Dubai-Miracle-Garden.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Dubai-Miracle-Garden.avif",
  "Travel-Rethinkways-SuperDeals-Dubai-Museum-of-the-Future.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Dubai-Museum-of-the-Future.avif",
  "Travel-Rethinkways-SuperDeals-Europe-Amsterdam-Canal-Cruise.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Europe-Amsterdam-Canal-Cruise.avif",
  "Travel-Rethinkways-SuperDeals-Europe-Buckingham-Palace.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Europe-Buckingham-Palace.avif",
  "Travel-Rethinkways-SuperDeals-Europe-Disneyland-Paris-Theme-Park.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Europe-Disneyland-Paris-Theme-Park.avif",
  "Travel-Rethinkways-SuperDeals-Europe-Eurail-Global-Pass.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Europe-Eurail-Global-Pass.avif",
  "Travel-Rethinkways-SuperDeals-Europe-Warner-Bros-Studio-Tour.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Europe-Warner-Bros-Studio-Tour.avif",
  "Travel-Rethinkways-SuperDeals-Georgia-KakhetiWineRegionTour.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Georgia-KakhetiWineRegionTour.avif",
  "Travel-Rethinkways-SuperDeals-Georgia-Tbilisi-Hop-On Hop.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Georgia-Tbilisi-Hop-On Hop.avif",
  "Travel-Rethinkways-SuperDeals-Japan-Kyoto.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Japan-Kyoto.avif",
  "Travel-Rethinkways-SuperDeals-Japan-ShibuyaSkyTicket.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Japan-ShibuyaSkyTicket.avif",
  "Travel-Rethinkways-SuperDeals-Malaysia-Genting-Highlands-Tour.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Malaysia-Genting-Highlands-Tour.avif",
  "Travel-Rethinkways-SuperDeals-Malaysia-Langkawi-Cable-Car.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Malaysia-Langkawi-Cable-Car.avif",
  "Travel-Rethinkways-SuperDeals-Malaysia-Langkawi-Island-Hopping.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Malaysia-Langkawi-Island-Hopping.avif",
  "Travel-Rethinkways-SuperDeals-Malaysia-Petronas-Twin-Towers.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Malaysia-Petronas-Twin-Towers.avif",
  "Travel-Rethinkways-SuperDeals-Malaysia-Sunway-Lagoon.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Malaysia-Sunway-Lagoon.avif",
  "Travel-Rethinkways-SuperDeals-Singapore-Gardens-by-the-Bay.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Singapore-Gardens-by-the-Bay.avif",
  "Travel-Rethinkways-SuperDeals-Singapore-Marina-Bay-Sands-SkyPark.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Singapore-Marina-Bay-Sands-SkyPark.avif",
  "Travel-Rethinkways-SuperDeals-Singapore-Night-Safari.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Singapore-Night-Safari.avif",
  "Travel-Rethinkways-SuperDeals-Singapore-Universal-Studios.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Singapore-Universal-Studios.avif",
  "Travel-Rethinkways-SuperDeals-Singapore-Wings-of-Time-Fireworks.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Singapore-Wings-of-Time-Fireworks.avif",
  "Travel-Rethinkways-SuperDeals-SouthKorea-NamiIsland.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-SouthKorea-NamiIsland.avif",
  "Travel-Rethinkways-SuperDeals-SouthKorea-SeoulSky.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-SouthKorea-SeoulSky.avif",
  "Travel-Rethinkways-SuperDeals-Sri-Lanka-Ella-Nine-Arches-Bridge.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Sri-Lanka-Ella-Nine-Arches-Bridge.avif",
  "Travel-Rethinkways-SuperDeals-Sri-Lanka-Sigiriya-Rock.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Sri-Lanka-Sigiriya-Rock.avif",
  "Travel-Rethinkways-SuperDeals-Sri-Lanka-Udawalawe-National-Park.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Sri-Lanka-Udawalawe-National-Park.avif",
  "Travel-Rethinkways-SuperDeals-Thailand-Alcazar-Cabaret-Pattaya.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Thailand-Alcazar-Cabaret-Pattaya.avif",
  "Travel-Rethinkways-SuperDeals-Thailand-Bangkok-Grand-Palace.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Thailand-Bangkok-Grand-Palace.avif",
  "Travel-Rethinkways-SuperDeals-Thailand-Chao-Phraya-Princess-Cruise.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Thailand-Chao-Phraya-Princess-Cruise.avif",
  "Travel-Rethinkways-SuperDeals-Thailand-Pattaya-Floating-Market.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Thailand-Pattaya-Floating-Market.avif",
  "Travel-Rethinkways-SuperDeals-Thailand-Safari-World-Bangkok.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Thailand-Safari-World-Bangkok.avif",
  "Travel-Rethinkways-SuperDeals-Thailand-elephant-jungle-sanctuary-pattaya.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Thailand-elephant-jungle-sanctuary-pattaya.avif",
  "Travel-Rethinkways-SuperDeals-Turkey-CappadociaSunriseHotAirBalloon.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Turkey-CappadociaSunriseHotAirBalloon.avif",
  "Travel-Rethinkways-SuperDeals-Turkey-Süleymaniye Mosque.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Turkey-Süleymaniye Mosque.avif",
  "Travel-Rethinkways-SuperDeals-Vietnam-Ambassador-Day-Cruise.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Vietnam-Ambassador-Day-Cruise.avif",
  "Travel-Rethinkways-SuperDeals-Vietnam-Coconut-Forest-Basket-Boat-Ride.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Vietnam-Coconut-Forest-Basket-Boat-Ride.avif",
  "Travel-Rethinkways-SuperDeals-Vietnam-Cu-Chi-Tunnels.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Vietnam-Cu-Chi-Tunnels.avif",
  "Travel-Rethinkways-SuperDeals-Vietnam-Lotte-World-Aquarium.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Vietnam-Lotte-World-Aquarium.avif",
  "Travel-Rethinkways-SuperDeals-Vietnam-Thang-Long-Water-Puppet.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Vietnam-Thang-Long-Water-Puppet.avif",
  "Travel-Rethinkways-SuperDeals-Vietnam-VinWonders-Phu-Quoc.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Vietnam-VinWonders-Phu-Quoc.avif",
};

// Hotel images
const IMG_HOTELS = {
  "Travel-Rethinkways-Hotels-Australia-Sydney-the-lord-nelson.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Australia-Sydney-the-lord-nelson.avif",
  "Travel-Rethinkways-Hotels-Azerbaijan-Baku-Holiday-Inn.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Azerbaijan-Baku-Holiday-Inn.avif",
  "Travel-Rethinkways-Hotels-Bali-Adiwana-Unagi-Suites.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Bali-Adiwana-Unagi-Suites.avif",
  "Travel-Rethinkways-Hotels-Bali-Aksari-Luxury-Resort.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Bali-Aksari-Luxury-Resort.avif",
  "Travel-Rethinkways-Hotels-Bali-Casa-Pohon.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Bali-Casa-Pohon.avif",
  "Travel-Rethinkways-Hotels-Bali-Hotel-Vila-Lumbung.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Bali-Hotel-Vila-Lumbung.avif",
  "Travel-Rethinkways-Hotels-Bali-LaMeli-Villas.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Bali-LaMeli-Villas.avif",
  "Travel-Rethinkways-Hotels-Bali-Nandini-Jungle.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Bali-Nandini-Jungle.avif",
  "Travel-Rethinkways-Hotels-Bali-Poppies.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Bali-Poppies.avif",
  "Travel-Rethinkways-Hotels-Bali-inara-alas-harum.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Bali-inara-alas-harum.avif",
  "Travel-Rethinkways-Hotels-Bali-the-box-paradise.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Bali-the-box-paradise.avif",
  "Travel-Rethinkways-Hotels-Dubai-Stay-Bridge-Suites.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Dubai-Stay-Bridge-Suites.avif",
  "Travel-Rethinkways-Hotels-Finland-Nova-Skyland.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Finland-Nova-Skyland.avif",
  "Travel-Rethinkways-Hotels-Georgia-Tbilisi-Jazz-Hotel.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Georgia-Tbilisi-Jazz-Hotel.avif",
  "Travel-Rethinkways-Hotels-Japan-Tokyo-Sotetsu-Fresa-Inn-Kanda-Otemachi.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Japan-Tokyo-Sotetsu-Fresa-Inn-Kanda-Otemachi.avif",
  "Travel-Rethinkways-Hotels-Kazakhstan-Almaty-Holiday-Inn-ALMATY-by-IHG.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Kazakhstan-Almaty-Holiday-Inn-ALMATY-by-IHG.avif",
  "Travel-Rethinkways-Hotels-Malaysia-Kuala-Lumpur-Neu-Suites-by-Moonlight.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Malaysia-Kuala-Lumpur-Neu-Suites-by-Moonlight.avif",
  "Travel-Rethinkways-Hotels-Maldives-Adaaran-Club-Rannalhi.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Maldives-Adaaran-Club-Rannalhi.avif",
  "Travel-Rethinkways-Hotels-Maldives-Dusit-Thani-Maldives.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Maldives-Dusit-Thani-Maldives.avif",
  "Travel-Rethinkways-Hotels-Maldives-Grand-Park-Kodhipparu.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Maldives-Grand-Park-Kodhipparu.avif",
  "Travel-Rethinkways-Hotels-Maldives-Machchafushi-Island-Resort_Spa.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Maldives-Machchafushi-Island-Resort_Spa.avif",
  "Travel-Rethinkways-Hotels-Maldives-Maldives-Honeymoon-Stay.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Maldives-Maldives-Honeymoon-Stay.avif",
  "Travel-Rethinkways-Hotels-Maldives-The-Standard.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Maldives-The-Standard.avif",
  "Travel-Rethinkways-Hotels-Singapore-A-Hotel-Bugis.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Singapore-A-Hotel-Bugis.avif",
  "Travel-Rethinkways-Hotels-Sri-Lanka-Colombo-Cinnamon-Lakeside.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Sri-Lanka-Colombo-Cinnamon-Lakeside.avif",
  "Travel-Rethinkways-Hotels-Thailand-Bangkok-City-Rama-9-Hotel.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Thailand-Bangkok-City-Rama-9-Hotel.avif",
  "Travel-Rethinkways-Hotels-Thailand-Bangkok-Picnic-Hotel.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Thailand-Bangkok-Picnic-Hotel.avif",
  "Travel-Rethinkways-Hotels-Thailand-Bangkok-Ramada-by-Wyndham.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Thailand-Bangkok-Ramada-by-Wyndham.avif",
  "Travel-Rethinkways-Hotels-Thailand-Krabi-GLOW-Ao-Nang-Krabi.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Thailand-Krabi-GLOW-Ao-Nang-Krabi.avif",
  "Travel-Rethinkways-Hotels-Thailand-Pattaya-April-suites.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Thailand-Pattaya-April-suites.avif",
  "Travel-Rethinkways-Hotels-Thailand-Pattaya-Bay-Beach-Resort-Jomtien.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Thailand-Pattaya-Bay-Beach-Resort-Jomtien.avif",
  "Travel-Rethinkways-Hotels-Thailand-Pattaya-LK-Emerald-Beach.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Thailand-Pattaya-LK-Emerald-Beach.avif",
  "Travel-Rethinkways-Hotels-Vietnam-Da-Nang-Santorin-HoiAn-Villa.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Vietnam-Da-Nang-Santorin-HoiAn-Villa.avif",
  "Travel-Rethinkways-Hotels-Vietnam-Hanoi-Splendid-Premium-Hotel.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Vietnam-Hanoi-Splendid-Premium-Hotel.avif",
  "Travel-Rethinkways-Hotels-Vietnam-Hanoi-Wyndham-Sky-Lake-Resorts.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Vietnam-Hanoi-Wyndham-Sky-Lake-Resorts.avif",
};

// Flight images
const IMG_FLIGHTS = {
  "Travel-Rethinkways-Flights-Bali Airlines.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Bali Airlines.avif",
  "Travel-Rethinkways-Flights-Bali.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Bali.avif",
  "Travel-Rethinkways-Flights-Dubai.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Dubai.avif",
  "Travel-Rethinkways-Flights-Hanoi.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Hanoi.avif",
  "Travel-Rethinkways-Flights-Ho Chi Minh-City.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Ho Chi Minh-City.avif",
  "Travel-Rethinkways-Flights-Hong Kong.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Hong Kong.avif",
  "Travel-Rethinkways-Flights-India-Destination.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-India-Destination.avif",
  "Travel-Rethinkways-Flights-India.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-India.avif",
  "Travel-Rethinkways-Flights-Kuala lumpur.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Kuala lumpur.avif",
  "Travel-Rethinkways-Flights-London.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-London.avif",
  "Travel-Rethinkways-Flights-Maldives.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Maldives.avif",
  "Travel-Rethinkways-Flights-Paris.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Paris.avif",
  "Travel-Rethinkways-Flights-Rome.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Rome.avif",
  "Travel-Rethinkways-Flights-Seoul.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Seoul.avif",
  "Travel-Rethinkways-Flights-Singapore.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Singapore.avif",
  "Travel-Rethinkways-Flights-Tokyo.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Tokyo.avif",
  "Travel-Rethinkways-Flights-baku.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-baku.avif",
  "Travel-Rethinkways-Flights-bangkok.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-bangkok.avif",
  "Travel-Rethinkways-Flights-istanbul.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-istanbul.avif",
  "Travel-Rethinkways-Flights-phuket.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-phuket.avif",
  "Travel-Rethinkways-Flights-tbilisi.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-tbilisi.avif",
};

// ─────────────────────────────────────────────────────────────
// IMAGE RESOLVER HELPER
// ─────────────────────────────────────────────────────────────

/**
 * Resolves an image path from a category folder and filename.
 * @param {"attractions"|"hotels"|"attractions"|"flights"} category
 * @param {string} filename
 * @returns {string}
 */
function resolveImage(category, filename) {
  const maps = {
    attractions: {
      ...IMG_ATTRACTIONS,
      "Travel-Rethinkways-SuperDeals-Andaman.avif": IMG_ANDAMAN,
      "Travel-Rethinkways-SuperDeals-Australia.avif": IMG_AUSTRALIA_DEST,
      "Travel-Rethinkways-SuperDeals-Azerbaijan.avif": IMG_AZERBAIJAN_DEST,
      "Travel-Rethinkways-SuperDeals-Bali.avif": IMG_BALI_DEST,
      "Travel-Rethinkways-SuperDeals-Delhi.avif": IMG_DELHI,
      "Travel-Rethinkways-SuperDeals-Dubai.avif": IMG_DUBAI_DEST,
      "Travel-Rethinkways-SuperDeals-Europe.avif": IMG_EUROPE_DEST,
      "Travel-Rethinkways-SuperDeals-Georgia.avif": IMG_GEORGIA_DEST,
      "Travel-Rethinkways-SuperDeals-Himachal.avif": IMG_HIMACHAL,
      "Travel-Rethinkways-SuperDeals-Japan.avif": IMG_JAPAN_DEST,
      "Travel-Rethinkways-SuperDeals-Karnataka.avif": IMG_KARNATAKA,
      "Travel-Rethinkways-SuperDeals-Kashmir.avif": IMG_KASHMIR,
      "Travel-Rethinkways-SuperDeals-Kazakhstan.avif": IMG_KAZAKHSTAN_DEST,
      "Travel-Rethinkways-SuperDeals-Kerala.avif": IMG_KERALA,
      "Travel-Rethinkways-SuperDeals-Maldives.avif": IMG_MALDIVES_DEST,
      "Travel-Rethinkways-SuperDeals-Meghalaya.avif": IMG_MEGHALAYA,
      "Travel-Rethinkways-SuperDeals-Rajasthan.avif": IMG_RAJASTHAN,
      "Travel-Rethinkways-SuperDeals-South Korea.avif": IMG_SOUTH_KOREA_DEST,
      "Travel-Rethinkways-SuperDeals-Sri Lanka.avif": IMG_SRI_LANKA_DEST,
      "Travel-Rethinkways-SuperDeals-Tamil Nadu.avif": IMG_TAMIL_NADU,
      "Travel-Rethinkways-SuperDeals-Thailand.avif": IMG_THAILAND_DEST,
      "Travel-Rethinkways-SuperDeals-Turkey.avif": IMG_TURKEY_DEST,
      "Travel-Rethinkways-SuperDeals-Vietnam.avif": IMG_VIETNAM_DEST,
      "Travel-Rethinkways-SuperDeals-goa.avif": IMG_GOA,
      "Travel-Rethinkways-SuperDealsMAlaysia.avif": IMG_MALAYSIA_DEST,
    },
    hotels: IMG_HOTELS,
    flights: IMG_FLIGHTS,
  };
  const map = maps[category];
  const aliases = {
    "Travel-Rethinkways-SuperDeals-Sri-Lanka.avif": IMG_SRI_LANKA_DEST,
    "Travel-Rethinkways-SuperDeals-Sri-Lanka-Sigiriya-Lion's-Rock.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Sri-Lanka-Sigiriya-Rock.avif",
    "Travel-Rethinkways-Hotels-Maldives-Machchafushi-Island-Resort&Spa.avif": "/assets/images/attractions/Travel-Rethinkways-Hotels-Maldives-Machchafushi-Island-Resort_Spa.avif",
    "Travel-Rethinkways-Flights-Ho Chi Minh City.avif": "/assets/images/attractions/Travel-Rethinkways-Flights-Ho Chi Minh-City.avif",
    "Travel-Rethinkways-SuperDeals-Turkey-S\u00FCleymaniye Mosque.avif": "/assets/images/attractions/Travel-Rethinkways-SuperDeals-Turkey-S\u00FCleymaniye Mosque.avif",
  };
  if (/Travel-Rethinkways-SuperDeals-Turkey-S.*leymaniye Mosque\.avif$/i.test(filename)) {
    return assetUrl("/assets/images/attractions/Travel-Rethinkways-SuperDeals-Turkey-S\u00FCleymaniye Mosque.avif");
  }
  return assetUrl((map && map[filename]) || aliases[filename] || "");
}

// Shorthand alias (mirrors original `a(category, filename)`)
const img = resolveImage;

// ─────────────────────────────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────────────────────────────

export const SUPER_DEALS_UPDATED_EVENT = "trw-super-deals-updated";

const STORAGE_KEYS = {
  CUSTOM: "trw-custom-super-deals-v1",
  SEED_OVERRIDES: "trw-seed-super-deals-overrides-v1",
  DELETED_IDS: "trw-deleted-seed-super-deals-ids-v1",
};

const WHATSAPP_NUMBER = "918438506813";

// ─────────────────────────────────────────────────────────────
// WHATSAPP URL BUILDER
// ─────────────────────────────────────────────────────────────

function buildDefaultWhatsAppMessage(dealTitle, category, isInternational) {
  const section = category === "Attractions"
    ? "Attractions section"
    : category === "Hotels"
      ? "Hotels section"
      : isInternational
        ? "International section"
        : "India section";

  return `Hi Travel Rethink Ways,\n\nI came across your "${dealTitle}" offer under ${section}.\n\nCould you please share more details?`;
}

function buildWhatsAppUrl(dealTitle, category, isInternational, number = WHATSAPP_NUMBER, message = "") {
  const normalizedNumber = String(number || "").replace(/\D/g, "") || WHATSAPP_NUMBER;
  const text = String(message || "").trim() || buildDefaultWhatsAppMessage(dealTitle, category, isInternational);
  return `https://wa.me/${normalizedNumber}?text=${encodeURIComponent(text)}`;
}

function extractWhatsAppMessage(value, fallback = "") {
  const raw = String(value || "").trim();
  if (!raw) return fallback;
  try {
    const parsed = new URL(raw);
    return parsed.searchParams.get("text")?.trim() || fallback;
  } catch {
    const [, textPart = ""] = raw.split("?text=");
    if (!textPart) return fallback;
    try {
      return decodeURIComponent(textPart).trim() || fallback;
    } catch {
      return textPart.trim() || fallback;
    }
  }
}

function extractWhatsAppNumber(value, fallback = WHATSAPP_NUMBER) {
  const raw = String(value || "").trim();
  if (!raw) return fallback;
  const match = raw.match(/wa\.me\/(\d+)/i);
  return match?.[1] || fallback;
}

// ─────────────────────────────────────────────────────────────
// SEED DEAL DATA – RAW
// ─────────────────────────────────────────────────────────────

const RAW_SEED_DEALS = [
  {
    id: 1,
    category: "Indian Escapes Deals",
    title: "Andaman",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Andaman.avif"),
    coupon: "ANDAMAN25",
    discount: "25%",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/#andaman",
    displayTitle: "Andaman - Coral Islands",
    displayDescription: "Island Offer | Save up to ₹5,000 off | Valid till: 15th July 2026",
    description: `Port Blair | Havelock | Neil Island\nCellular Jail Tour . Radhanagar Beach . Elephant Beach`,
    badgeText: "LIMITED TIME",
    offerText: "Upto ₹5,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "100+ Travelers booked",
    primaryCta: "Today's Deal",
    secondaryCta: "Check Out",
  },
  {
    id: 2,
    category: "International Getaway Deals",
    title: "Australia",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Australia.avif"),
    coupon: "FLYMORE50",
    discount: "50%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#australia",
    displayTitle: "Australia - Island Continent",
    displayDescription: "Long-Haul Explorer Offer | Save up to ₹5,000 | Valid till: 15th July 2026",
    description: `Sydney | Melbourne\nOpera House . Great Ocean Road . Blue Mountains`,
    badgeText: "EXCLUSIVE DEAL",
    offerText: "Upto ₹15,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "120+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 3,
    category: "International Getaway Deals",
    title: "Azerbaijan",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Azerbaijan.avif"),
    coupon: "BALIHOL50",
    discount: "50%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#azerbaijan",
    displayTitle: "Azerbaijan - Silk Road",
    displayDescription: "City Travel Offer| Get upto ₹5,000 off | Valid till: 15th July 2026",
    description: `Baku | Gabala\nFlame Towers . Cable Car . Gobustan Mud Volcano`,
    badgeText: "TRENDING",
    offerText: "Upto ₹6,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "90+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 4,
    category: "International Getaway Deals",
    title: "Bali",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Bali.avif"),
    coupon: "SAFE25",
    discount: "25%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#bali",
    displayTitle: "Bali - Sunset Paradise",
    displayDescription: "Romantic Island Offer |Get up to ₹10,000 off | Valid till: 15th July 2026",
    description: `Kuta | Ubud\nBali Swing . Ubud Rice Terraces . Temple Tours`,
    badgeText: "HOT SELLING",
    offerText: "Upto ₹8,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "320+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 5,
    category: "Indian Escapes Deals",
    title: "Delhi",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Delhi.avif"),
    coupon: "RELAX20",
    discount: "20%",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/#delhi",
    displayTitle: "Delhi - Cultural Crossroads",
    displayDescription: "City Travel Offer| Get upto ₹5,000 off | Valid till: 15th July 2026",
    description: `Delhi | Agra\nIndia Gate . Taj Mahal . Red Fort`,
    badgeText: "LIMITED TIME",
    offerText: "Upto ₹5,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "150+ Travelers booked",
    primaryCta: "Today's Deal",
    secondaryCta: "Check Out",
  },
  {
    id: 6,
    category: "International Getaway Deals",
    title: "Dubai",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Dubai.avif"),
    coupon: "STAYMORE30",
    discount: "30%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#dubai",
    displayTitle: "Dubai - Skyline City",
    displayDescription: "Luxury City Break Offer |Receive up to ₹15,000 off | Valid till: 15th July 2026",
    description: `Dubai | Abu Dhabi\nBurj Khalifa . Desert Safari . Ferrari World`,
    badgeText: "LIMITED TIME",
    offerText: "Upto ₹8,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "300+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 7,
    category: "International Getaway Deals",
    title: "Europe",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Europe.avif"),
    coupon: "MOVE15",
    discount: "15%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#europe",
    displayTitle: "Europe - Continental Journey",
    displayDescription: "Multi-Country Journey Offer: Save up to ₹20,000 | Valid till: 15th July 2026",
    description: `Paris + Switzerland + Italy\nEiffel Tower . Swiss Alps . Venice Canals`,
    badgeText: "EXCLUSIVE DEAL",
    offerText: "Upto ₹15,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "140+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 8,
    category: "International Getaway Deals",
    title: "Georgia",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Georgia.avif"),
    coupon: "GEAR20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#georgia",
    displayTitle: "Georgia - Mountain Charm",
    displayDescription: "Caucasus Mountain Offer | Enjoy up to ₹15,000| Valid till: 15th July 2026",
    description: `Tbilisi | Gudauri\nOld Town . Ananuri Fortress . Mountain Views`,
    badgeText: "EXCLUSIVE DEAL",
    offerText: "Upto ₹8,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "110+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 9,
    category: "Indian Escapes Deals",
    title: "Goa",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-goa.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/#goa",
    displayTitle: "Goa - Sunset Shores",
    displayDescription: "Beach Getaway Offer|Enjoy up to ₹5,000 off | Valid till: 15th July 2026",
    description: `North Goa | South Goa\nBaga Beach . Dudhsagar Falls . Sunset Cruise`,
    badgeText: "LIMITED TIME",
    offerText: "Upto ₹4,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "200+ Travelers booked",
    primaryCta: "Today's Deal",
    secondaryCta: "Check Out",
  },
  {
    id: 10,
    category: "Indian Escapes Deals",
    title: "Himachal",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Himachal.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/#himachal",
    displayTitle: "Himachal - Alpine Beauty",
    displayDescription: "Mountain Escape Offer|Receive up to ₹5,000 savings | Valid till: 15th July 2026",
    description: `Shimla | Manali | Dalhousie\nAtal Tunnel . Rohtang Pass . River Rafting`,
    badgeText: "LIMITED TIME",
    offerText: "Upto ₹5,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "220+ Travelers booked",
    primaryCta: "Today's Deal",
    secondaryCta: "Check Out",
  },
  {
    id: 11,
    category: "International Getaway Deals",
    title: "Japan",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Japan.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#japan",
    displayTitle: "Japan - Zen Landscapes",
    displayDescription: "Seasonal Wonders Offer | Get up to ₹20,000 off| Valid till: 15th July 2026",
    description: `Tokyo | Osaka | Kyoto\nMount Fuji . Bullet Train . Arashiyama Bamboo Grove`,
    badgeText: "EXCLUSIVE DEAL",
    offerText: "Upto ₹12,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "90+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 12,
    category: "Indian Escapes Deals",
    title: "Karnataka",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Karnataka.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/#karnataka",
    displayTitle: "Karnataka - Heritage Trails",
    displayDescription: "Heritage & Nature Offer|Unlock up to ₹5,000 off | Valid till: 15th July 2026",
    description: `Coorg | Chikmagalur | Mysore\nAbbey Falls . Coffee Plantations . Mullayanagiri Peak`,
    badgeText: "LIMITED TIME",
    offerText: "Upto ₹4,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "140+ Travelers booked",
    primaryCta: "Today's Deal",
    secondaryCta: "Check Out",
  },
  {
    id: 13,
    category: "Indian Escapes Deals",
    title: "Kashmir",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Kashmir.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/#kashmir",
    displayTitle: "Kashmir - Snow Paradise",
    displayDescription: "Valley Travel Offer | Enjoy exclusive deal up to ₹5,000 | Valid till: 15th July 2026",
    description: `Srinagar | Gulmarg | Pahalgam\nShikara Ride . Gondola Ride . Betaab Valley`,
    badgeText: "SPRING OFFER",
    offerText: "Upto ₹6,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "260+ Travelers booked",
    primaryCta: "Today's Deal",
    secondaryCta: "Check Out",
  },
  {
    id: 14,
    category: "International Getaway Deals",
    title: "Kazakhstan",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Kazakhstan.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#kazakhstan",
    displayTitle: "Kazakhstan - Scenic Steppe",
    displayDescription: "Central Asia Explorer Offer|Enjoy up to ₹15,000 savings | Valid till: 15th July 2026",
    description: `Almaty\nKok Tobe . Big Almaty Lake . Shymbulak Ski Resort`,
    badgeText: "LIMITED TIME",
    offerText: "Upto ₹5,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "70+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 15,
    category: "Indian Escapes Deals",
    title: "Kerala",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Kerala.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/#kerala",
    displayTitle: "Kerala - Backwater Bliss",
    displayDescription: "Backwater Escape Offer|Save up to ₹5,000 off | Valid till: 15th July 2026",
    description: `Munnar | Alleppey | Thekkady\nAbbey Falls . Coffee Plantations . Mullayanagiri Peak`,
    badgeText: "MONSOON SPECIAL",
    offerText: "Upto ₹5,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "210+ Travelers booked",
    primaryCta: "Today's Deal",
    secondaryCta: "Check Out",
  },
  {
    id: 16,
    category: "International Getaway Deals",
    title: "Malaysia",
    image: img("attractions", "Travel-Rethinkways-SuperDealsMAlaysia.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#malaysia",
    displayTitle: "Malaysia - Urban Tropics",
    displayDescription: "Island & City Escape Offer| Receive up to ₹10,000 discount | Valid till: 15th July 2026",
    description: `Kuala Lumpur | Langkawi\nPetronas Towers . Sky Bridge . Island Hopping`,
    badgeText: "HOT SELLING",
    offerText: "Upto ₹6,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "220+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 17,
    category: "International Getaway Deals",
    title: "Maldives",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Maldives.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#maldives",
    displayTitle: "Maldives - Ocean Paradise",
    displayDescription: "Luxury Island Escape Offer|Save up to ₹15,000| Valid till: 15th July 2026",
    description: `Maldives\nWater Villa . Snorkeling . Sunset Cruise`,
    badgeText: "EXCLUSIVE DEAL",
    offerText: "Upto ₹10,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "180+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: "17b",
    category: "International Getaway Deals",
    title: "Singapore",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Singapore-Universal-Studios.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#singapore",
    displayTitle: "Singapore - City of Fun & Thrills",
    displayDescription: "",
    description: `Singapore\nUniversal Studios . Sentosa . Night Safari`,
    badgeText: "HOT SELLING",
    offerText: "Upto ₹6,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "190+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 18,
    category: "Indian Escapes Deals",
    title: "Meghalaya",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Meghalaya.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/#meghalaya",
    displayTitle: "Meghalaya - Cloud Kingdom",
    displayDescription: "Nature Explorer Offer|Get up to ₹5,000 discount | Valid till: 15th July 2026",
    description: `Shillong | Cherrapunji\nLiving Root Bridges . Dawki River . Nohkalikai Falls`,
    badgeText: "OFFBEAT ESCAPE",
    offerText: "Upto ₹5,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "120+ Travelers booked",
    primaryCta: "Today's Deal",
    secondaryCta: "Check Out",
  },
  {
    id: 19,
    category: "Indian Escapes Deals",
    title: "Rajasthan",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Rajasthan.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/#rajasthan",
    displayTitle: "Rajasthan - Desert Kingdom",
    displayDescription: "Royal Journey Offer | Enjoy up to ₹5,000 discount | Valid till: 15th July 2026",
    description: `Jaipur | Udaipur\nAmber Fort . City Palace . Lake Pichola`,
    badgeText: "EXCLUSIVE DEAL",
    offerText: "Upto ₹5,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "240+ Travelers booked",
    primaryCta: "Today's Deal",
    secondaryCta: "Check Out",
  },
  {
    id: 20,
    category: "International Getaway Deals",
    title: "South Korea",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-South Korea.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#korea",
    displayTitle: "South Korea - Urban Explorations",
    displayDescription: "Seoul Discovery Offer | Get ₹20,000 off| Valid till: 15th July 2026",
    description: `Seoul | Busan\nGyeongbokgung Palace . N Seoul Tower . Haeundae Beach`,
    badgeText: "EXCLUSIVE DEAL",
    offerText: "Upto ₹10,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "140+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 21,
    category: "International Getaway Deals",
    title: "Sri Lanka",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Sri Lanka.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#srilanka",
    displayTitle: "Sri Lanka - Scenic Lanka",
    displayDescription: "Island Culture Offer |Enjoy up to ₹5,000 savings | Valid till: 15th July 2026",
    description: `Kandy | Bentota | Colombo\nTemple of Tooth . Bentota Beach . City Tour`,
    badgeText: "LIMITED TIME",
    offerText: "Upto ₹6,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "170+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 22,
    category: "Indian Escapes Deals",
    title: "Tamil Nadu",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Tamil Nadu.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/india-travel-deals-2026/#tamilnadu",
    displayTitle: "Tamil Nadu - Cultural South",
    displayDescription: "Cultural Travel Offer | Receive up to ₹5,000 discount | Valid till: 15th July 2026",
    description: `Madurai | Rameswaram\nMeenakshi Temple . Pamban Bridge . Dhanushkodi`,
    badgeText: "EXCLUSIVE DEAL",
    offerText: "Upto ₹4,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "00+ Travelers booked",
    primaryCta: "Today's Deal",
    secondaryCta: "Check Out",
  },
  {
    id: 23,
    category: "International Getaway Deals",
    title: "Thailand",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Thailand.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#thailand",
    displayTitle: "Thailand - Beach Kingdom",
    displayDescription: "Island Adventure Offer |Save up to ₹10,000| Valid till: 15th July 2026",
    description: `Bangkok | Pattaya\nCoral Island . Alcazar Show . Safari World`,
    badgeText: "TRENDING",
    offerText: "Upto ₹7,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "280+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 24,
    category: "International Getaway Deals",
    title: "Turkey",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Turkey.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#turkey",
    displayTitle: "Turkey - Ottoman Heritage",
    displayDescription: "Historic Journey Offer | Get up to ₹15,000 off |Valid till: 15th July 2026",
    description: `Istanbul | Cappadocia\nHagia Sophia . Hot Air Balloon . Blue Mosque`,
    badgeText: "HOT SELLING",
    offerText: "Upto ₹9,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "100+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  {
    id: 25,
    category: "International Getaway Deals",
    title: "Vietnam",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Vietnam.avif"),
    coupon: "CITYDAY20",
    discount: "20%",
    link: "https://travel.rethinkways.com/international-travel-deals-2026/#vietnam",
    displayTitle: "Vietnam - Ha Long Wonders",
    displayDescription: "Southeast Asia Explorer Offer|Receive ₹15,000 savings|Valid till: 15th July 2026",
    description: `Hanoi | Ha Long Bay | Hoi An\nCruise Stay . Old Quarter . Ancient Town`,
    badgeText: "TRENDING",
    offerText: "Upto ₹7,000 OFF",
    validUntil: "15th July 2026",
    audienceText: "210+ travelers booked",
    primaryCta: "Unlock Deal",
    secondaryCta: "Get Quote",
  },
  // ── ATTRACTIONS ──────────────────────────────────────────────
  {
    id: 26, category: "Attractions", title: "Mount Batur Sunrise Jeep Tour",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Bali-Mount-Batur-Sunrise.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235920&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F96022-mount-batur-jeep-trekking-sunrise-kintamani-bali%2F",
    description: "Epic sunrise above Bali's volcano | Jeep ride & trekking adventure",
  },
  {
    id: 27, category: "Attractions", title: "Snorkeling Experience in Nusa Penida",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Bali-Snorkeling-Experience.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235921&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F122675-snorkeling-experience-in-nusa-penida-4-snorkeling-spots%2F",
    description: "Swim with vibrant marine life | Crystal-clear waters & coral reefs",
  },
  {
    id: 28, category: "Attractions", title: "Bali ATV Ride & Ayung River Rafting",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Bali-ATV-Ride.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235923&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F18269-atv-ride-ayung-rafting-bali%2F",
    description: "Jungle ATV trails & thrilling white-water rafting | Adventure with lunch",
  },
  {
    id: 29, category: "Attractions", title: "Uluwatu Temple Kecak & Fire Dance Show",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Bali- Fire-Dance.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235924&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F21638-uluwatu-kecak-fire-dance-show-tickets-bali%2F",
    description: "Epic sunset views & traditional Balinese fire dance performance",
  },
  {
    id: 30, category: "Attractions", title: "Bali Safari Park Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Bali-Safari-Park.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235925&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F170-bali-safari-and-marine-park-bali%2F",
    description: "Wildlife encounters & safari adventure | See animals up close",
  },
  {
    id: 31, category: "Attractions", title: "Waterbom Bali Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Bali-Waterbom-Bali.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235926&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F175-waterbom-bali%2F",
    description: "Asia's top waterpark thrills | Slides, pools & tropical fun",
  },
  {
    id: 32, category: "Attractions", title: "Lovina Dolphin Watching & Snorkeling Tour",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Bali-Lovina-Dolphin.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235928&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F33382-lovina-dolphin-watching-snorkeling-tour-bali%2F",
    description: "Sunrise dolphin spotting & reef snorkeling | A magical experience",
  },
  {
    id: 33, category: "Attractions", title: "Garuda Wisnu Kencana Cultural Park Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Bali-Garuda-Wisnu-Kencana-Cultural-Park.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235930&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F13234-garuda-wisnu-kencana-cultural-park-admission-ticket-bali%2F",
    description: "Home to Bali's giant statue | Culture, views & iconic landmarks",
  },
  {
    id: 34, category: "Attractions", title: "Lotte World Aquarium Hanoi Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Vietnam-Lotte-World-Aquarium.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235933&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F109708-ha-noi-lotte-world-aquarium%2F",
    description: "Explore thousands of marine creatures | Walk through ocean tunnels",
  },
  {
    id: 35, category: "Attractions", title: "Thang Long Water Puppet Show Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Vietnam-Thang-Long-Water-Puppet.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235934&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F35653-thang-long-water-puppet-show-ticket-hanoi%2F",
    description: "Traditional Vietnamese storytelling on water | Live music & cultural performance",
  },
  {
    id: 36, category: "Attractions", title: "Ambassador Day Cruise - Ha Long Bay",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Vietnam-Ambassador-Day-Cruise.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235935&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F36086-halong-bay-cruise-tour-hanoi%2F",
    description: "Luxury cruise through limestone islands | Visit Sung Sot Cave & Ti Top Island",
  },
  {
    id: 37, category: "Attractions", title: "Cu Chi Tunnels & Mekong Delta Luxury Day Tour",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Vietnam-Cu-Chi-Tunnels.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235937&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F858-cu-chi-tunnesl-mekong-river-day-tour-hochiminh%2F",
    description: "Historic tunnels & river landscapes | Vietnam's wartime history experience",
  },
  {
    id: 38, category: "Attractions", title: "VinWonders Phu Quoc Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Vietnam-VinWonders-Phu-Quoc.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235939&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F11989-vinwonders-phu-quoc-ticket%2F",
    description: "Thrilling rides & water park fun | Vietnam's largest theme park",
  },
  {
    id: 39, category: "Attractions", title: "Coconut Forest Basket Boat Ride - Hoi An",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Vietnam-Coconut-Forest-Basket-Boat-Ride.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235940&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F24274-basket-boat-ticket-hoi-an-coconut-forest%2F",
    description: "Spin through palm canals | Unique basket boat adventure",
  },
  {
    id: 40, category: "Attractions", title: "Elephant Jungle Sanctuary Pattaya Experience",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Thailand-elephant-jungle-sanctuary-pattaya.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235941&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F8053-elephant-jungle-sanctuary-pattaya-experience%2F",
    description: "Ethical elephant encounters | Feed, bathe & learn about them",
  },
  {
    id: 41, category: "Attractions", title: "Pattaya Floating Market Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Thailand-Pattaya-Floating-Market.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235942&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F2920-floating-market-pattaya%2F",
    description: "Traditional market on water | Boats, food & local culture",
  },
  {
    id: 42, category: "Attractions", title: "Alcazar Cabaret Pattaya Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Thailand-Alcazar-Cabaret-Pattaya.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235945&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F2321-alcazar-cabaret-pattaya%2F",
    description: "Dazzling costumes & stage performances | Thailand's iconic cabaret show",
  },
  {
    id: 43, category: "Attractions", title: "Safari World Bangkok Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Thailand-Safari-World-Bangkok.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235947&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F365-safari-world-bangkok%2F",
    description: "Open zoo safari adventure | Wildlife shows & animal encounters",
  },
  {
    id: 44, category: "Attractions", title: "Chao Phraya Princess Cruise - Bangkok",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Thailand-Chao-Phraya-Princess-Cruise.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235948&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F375-chao-phraya-princess-cruise-bangkok%2F",
    description: "Dinner cruise with city skyline views | Live music on the river",
  },
  {
    id: 45, category: "Attractions", title: "Bangkok Grand Palace & Emerald Buddha Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Thailand-Bangkok-Grand-Palace.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235950&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F129462-skip-the-line-grand-palace-and-emerald-buddha-ticket-in-bangkok%2F",
    description: "Thailand's most sacred temple complex | Royal heritage & stunning architecture",
  },
  {
    id: 46, category: "Attractions", title: "Sunway Lagoon Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Malaysia-Sunway-Lagoon.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235951&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F1303-sunway-lagoon-kuala-lumpur%2F",
    description: "Water rides & theme park thrills | One of Malaysia's top parks",
  },
  {
    id: 47, category: "Attractions", title: "Petronas Twin Towers Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Malaysia-Petronas-Twin-Towers.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235953&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F2750-petronas-twin-towers-kuala-lumpur%2F",
    description: "Skybridge views above Kuala Lumpur | Visit the iconic twin towers",
  },
  {
    id: 48, category: "Attractions", title: "Genting Highlands Tour with Awana Cable Car",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Malaysia-Genting-Highlands-Tour.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235955&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F34287-batu-caves-genting-highlands-private-day-tour%2F",
    description: "Cool mountain escape | Scenic cable car & outlet shopping",
  },
  {
    id: 49, category: "Attractions", title: "Langkawi Cable Car Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Malaysia-Langkawi-Cable-Car.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235957&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F23229-cable-car-admission-ticket-langkawi%2F",
    description: "Ride above rainforest peaks | Stunning views from SkyCab",
  },
  {
    id: 50, category: "Attractions", title: "Langkawi VIP 5-in-1 Island Hopping Tour",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Malaysia-Langkawi-Island-Hopping.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235958&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F102760-langkawi-vip-5in1-island-hopping-tour%2F",
    description: "Explore hidden islands | Beaches, eagles & crystal waters",
  },
  {
    id: 51, category: "Attractions", title: "Sigiriya Lion's Rock Fortress Day Tour & Village Experience",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Sri-Lanka-Sigiriya-Rock.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235962&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F9059-sigiriya-lions-rock-fortress-day-tour-colombo%2F",
    description: "Climb the ancient rock citadel | Village life & cultural experience",
  },
  {
    id: 52, category: "Attractions", title: "Ella Nine Arches Bridge & Little Adam's Peak Tour",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Sri-Lanka-Ella-Nine-Arches-Bridge.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235963&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F128332-ella-day-tour-departing-from-any-location-in-sri-lanka%2F",
    description: "Iconic railway bridge views | Scenic hike in Ella hills",
  },
  {
    id: 53, category: "Attractions", title: "Udawalawe National Park Safari Experience",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Sri-Lanka-Udawalawe-National-Park.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236007&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F17335-udawalawe-national-park-safari-mirissa%2F",
    description: "Wild elephant sightings | Jeep safari through open grasslands",
  },
  {
    id: 54, category: "Attractions", title: "Universal Studios Singapore Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Singapore-Universal-Studios.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235967&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F117-universal-studios-singapore%2F",
    description: "Hollywood movie rides & attractions | Thrills for all ages",
  },
  {
    id: 55, category: "Attractions", title: "Gardens by the Bay Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Singapore-Gardens-by-the-Bay.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235968&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F127-gardens-by-the-bay-singapore%2F",
    description: "Futuristic gardens & Supertrees | Nature meets innovation",
  },
  {
    id: 56, category: "Attractions", title: "Night Safari Ticket - Mandai Wildlife Reserve",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Singapore-Night-Safari.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235969&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F3928-singapore-night-safari-singapore%2F",
    description: "World's first nocturnal zoo | Wildlife adventure after dark",
  },
  {
    id: 57, category: "Attractions", title: "Wings of Time Fireworks Symphony Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Singapore-Wings-of-Time-Fireworks.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235970&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F135-wings-of-time-singapore%2F",
    description: "Lights, lasers & fireworks show | Magical night by the sea",
  },
  {
    id: 58, category: "Attractions", title: "Marina Bay Sands SkyPark Observation Deck Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Singapore-Marina-Bay-Sands-SkyPark.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235971&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F10552-marina-bay-sands-skypark-observation-deck-admission-ticket-singapore%2F",
    description: "Sky-high city views | Iconic rooftop observation deck",
  },
  {
    id: 59, category: "Attractions", title: "Museum of the Future Ticket - Dubai",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Dubai-Museum-of-the-Future.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235972&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F68223-museum-future-admission-dubai%2F",
    description: "Step into tomorrow's innovations | Futuristic exhibits & immersive technology",
  },
  {
    id: 60, category: "Attractions", title: "Dubai Miracle Garden Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Dubai-Miracle-Garden.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235973&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F30333-miracle-garden-ticket-dubai%2F",
    description: "World's largest flower garden | Millions of blooms in stunning designs",
  },
  {
    id: 61, category: "Attractions", title: "Dubai Marina Dhow Cruise",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Dubai-Marina-Dhow-Cruise.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235976&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F6168-marina-dinner-cruise-dubai%2F",
    description: "Dinner cruise with skyline views | Traditional dhow on Dubai Marina",
  },
  {
    id: 62, category: "Attractions", title: "Burj Khalifa - At The Top Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Dubai-Burj-Khalifa.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235977&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F2228-burj-khalifa-observation-deck-dubai%2F",
    description: "Views from the world's tallest tower | Iconic Dubai skyline experience",
  },
  {
    id: 63, category: "Attractions", title: "Sydney Opera House Tour & Dine Experience",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Australia-sydney-opera-house.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235978&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F59047-sydney-opera-house-tour-dine-sydney-opera-kitchen-sydney%2F",
    description: "Explore Australia's iconic landmark | Guided tour with dining experience",
  },
  {
    id: 64, category: "Attractions", title: "Gobustan, Mud Volcanoes & Fire Temple Tour - Baku",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Azerbaijan-MudVolcanoes.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235981&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F190911-eternal-flames-stone-legends-gobustan-and-absheron-day-tour%2F",
    description: "Ancient rock carvings & mud volcanoes | Azerbaijan's natural wonders",
  },
  {
    id: 65, category: "Attractions", title: "Baku Old City Cultural Walking Tour",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Azerbaijan-Baku-Old-City.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235982&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F187184-baku-old-city-half-day-cultural-walking-tour%2F",
    description: "Historic streets & medieval landmarks | Discover UNESCO-listed Old City",
  },
  {
    id: 66, category: "Attractions", title: "Disneyland Paris Theme Park Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Europe-Disneyland-Paris-Theme-Park.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235983&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F3969-disneyland-resort-paris%2F",
    description: "Fairytale rides & Disney magic | Europe's most magical theme park",
  },
  {
    id: 67, category: "Attractions", title: "Amsterdam Canal Cruise Experience",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Europe-Amsterdam-Canal-Cruise.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235984&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F2810-canal-cruise-amsterdam%2F",
    description: "Scenic cruise through historic canals | Iconic views of Amsterdam",
  },
  {
    id: 68, category: "Attractions", title: "Eurail Global Pass",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Europe-Eurail-Global-Pass.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235990&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F9868-eurail-global-rail-pass%2F",
    description: "Unlimited train travel across Europe | Explore multiple countries easily",
  },
  {
    id: 69, category: "Attractions", title: "Warner Bros. Studio Tour London - Harry Potter",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Europe-Warner-Bros-Studio-Tour.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235992&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F95658-warner-bros-studio-tour-central-london%2F",
    description: "Step into the wizarding world | Behind the scenes of Hogwarts",
  },
  {
    id: 70, category: "Attractions", title: "Buckingham Palace, Big Ben & Westminster Abbey Tour",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Europe-Buckingham-Palace.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235994&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F115676-london-buckingham-palace-big-ben-westminster-abbey-entry%2F",
    description: "Royal landmarks & historic sights | Discover London's iconic trio",
  },
  {
    id: 71, category: "Attractions", title: "Kakheti Wine Region Tour - Tbilisi",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Georgia-KakhetiWineRegionTour.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235996&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F29476-kakheti-wine-region-tour-tbilisi%2F",
    description: "Georgia's famous wine country | Vineyards, tastings & scenic landscapes",
  },
  {
    id: 72, category: "Attractions", title: "Tbilisi Hop-On Hop-Off City Tour",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Georgia-Tbilisi-Hop-On Hop.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235997&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F189103-tbilisi-12-stop-city-sightseeing-hop-on-hop-off-tour%2F",
    description: "Explore the city at your pace | 12 stops across major attractions",
  },
  {
    id: 73, category: "Attractions", title: "Shibuya Sky Ticket - Tokyo",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Japan-ShibuyaSkyTicket.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1235998&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F70672-shibuya-sky-tokyo%2F",
    description: "Open-air rooftop views | Tokyo skyline from above Shibuya",
  },
  {
    id: 74, category: "Attractions", title: "Kyoto, Arashiyama, Fushimi Inari & Nara Tour",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Japan-Kyoto.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236000&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F110001-kyoto-nara-deer-arashiyama-train-cherry-blossom-one-day-tour%2F",
    description: "Temples, bamboo forest & friendly deer | Kyoto region highlights",
  },
  {
    id: 75, category: "Attractions", title: "Istanbul Tourist Pass - 100+ Attractions",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Turkey-Süleymaniye Mosque.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236001&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F141966-istanbul-tourist-pass-skip-the-line-entry-to-100-attractions%2F",
    description: "Skip lines at top landmarks | One pass for Istanbul highlights",
  },
  {
    id: 76, category: "Attractions", title: "Cappadocia Sunrise Hot Air Balloon Flight",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-Turkey-CappadociaSunriseHotAirBalloon.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236003&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F154617-cappadocia-sunrise-hot-air-balloon-flight-with-champagne%2F",
    description: "Float above fairy chimneys | Sunrise views with champagne toast",
  },
  {
    id: 77, category: "Attractions", title: "Nami Island, Alpaca & Rail Bike Tour - Seoul",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-SouthKorea-NamiIsland.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236004&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F2528-nami-island-garden-morning-calm-seoul%2F",
    description: "Cherry blossom scenery | Rail bike ride & alpaca encounters",
  },
  {
    id: 78, category: "Attractions", title: "Seoul Sky - Lotte World Tower Ticket",
    image: img("attractions", "Travel-Rethinkways-SuperDeals-SouthKorea-SeoulSky.avif"),
    coupon: "ATTRACTIONS25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236005&k_site=https%3A%2F%2Fwww.klook.com%2Factivity%2F17678-lotte-world-sky-admission%2F",
    description: "Sky-high views from Korea's tallest tower | Seoul skyline panorama",
  },
  // ── HOTELS ──────────────────────────────────────────────────
  {
    id: 79, category: "Hotels", countryCity: "Maldives", title: "Dusit Thani Maldives", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Maldives-Dusit-Thani-Maldives.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236044&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F243391%3F",
    displayTitle: "Dusit Thani Maldives",
    displayDescription: "Luxury overwater villas | Coral reef snorkeling & private island escape",
    description: "Luxury overwater villas | Coral reef snorkeling & private island escape",
    cta: "See Availability",
  },
  // id 80 is excluded (filtered out in original)
  {
    id: 81, category: "Hotels", countryCity: "Maldives", title: "Adaaran Club Rannalhi - 45 Minutes away from Male by Speedboat", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Maldives-Adaaran-Club-Rannalhi.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236046&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F61435%3F",
    displayTitle: "Adaaran Club Rannalhi - Maldives",
    displayDescription: "Easy speedboat access from Male | Beach & overwater villas escape",
    description: "Easy speedboat access from Male | Beach & overwater villas escape",
    cta: "See Availability",
  },
  {
    id: 82, category: "Hotels", countryCity: "Maldives", title: "Machchafushi Island Resort & Spa Maldives, The Centara Collection", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Maldives-Machchafushi-Island-Resort_Spa.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236047&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F504477%3F",
    displayTitle: "Machchafushi Island Resort & Spa - Centara Collection",
    displayDescription: "Private island luxury | Lagoon villas & vibrant house reef",
    description: "Private island luxury | Lagoon villas & vibrant house reef",
    cta: "See Availability",
  },
  {
    id: 83, category: "Hotels", countryCity: "Maldives", title: "The Standard, Maldives", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Maldives-The-Standard.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236049&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F238328%3F",
    displayTitle: "The Standard, Maldives",
    displayDescription: "Trendy island retreat | Overwater villas & lagoon views",
    description: "Trendy island retreat | Overwater villas & lagoon views",
    cta: "See Availability",
  },
  {
    id: 84, category: "Hotels", countryCity: "Maldives", title: "Grand Park Kodhipparu", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Maldives-Grand-Park-Kodhipparu.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236050&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F584222%3F",
    displayTitle: "Grand Park Kodhipparu - Maldives",
    displayDescription: "Luxury villas near Male | Infinity pool & turquoise lagoon",
    description: "Luxury villas near Male | Infinity pool & turquoise lagoon",
    cta: "See Availability",
  },
  {
    id: 85, category: "Hotels", countryCity: "Bali", title: "Adiwana Unagi Suites Ubud", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Bali-Adiwana-Unagi-Suites.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236052&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F583849%3F",
    displayTitle: "Adiwana Unagi Suites - Ubud",
    displayDescription: "Peaceful jungle retreat | Elegant suites with tropical views",
    description: "Peaceful jungle retreat | Elegant suites with tropical views",
    cta: "See Availability",
  },
  {
    id: 86, category: "Hotels", countryCity: "Bali", title: "Poppies Bali", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Bali-Poppies.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236053&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F390934%3F",
    displayTitle: "Poppies Bali - Kuta",
    displayDescription: "Charming garden hideaway | Traditional cottages near Kuta Beach",
    description: "Charming garden hideaway | Traditional cottages near Kuta Beach",
    cta: "See Availability",
  },
  {
    id: 87, category: "Hotels", countryCity: "Bali", title: "Casa Pohon Ubud", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Bali-Casa-Pohon.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236054&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F952445%3F",
    displayTitle: "Casa Pohon - Ubud",
    displayDescription: "Cliffside treehouse stay | Stunning jungle valley views",
    description: "Cliffside treehouse stay | Stunning jungle valley views",
    cta: "See Availability",
  },
  {
    id: 88, category: "Hotels", countryCity: "Bali", title: "Aksari Luxury Resort & Spa Ubud by Ini Vie Hospitality", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Bali-Aksari-Luxury-Resort.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236056&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F442672%3F",
    displayTitle: "Aksari Luxury Resort & Spa - Ubud",
    displayDescription: "Romantic jungle resort | Infinity pool & luxury villas",
    description: "Romantic jungle resort | Infinity pool & luxury villas",
    cta: "See Availability",
  },
  {
    id: 89, category: "Hotels", countryCity: "Bali", title: "Inara Alas Harum", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Bali-inara-alas-harum.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236057&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F1266750%3F",
    displayTitle: "Inara Alas Harum - Bali",
    displayDescription: "Nature-inspired retreat | Rice terrace views & peaceful stay",
    description: "Nature-inspired retreat | Rice terrace views & peaceful stay",
    cta: "See Availability",
  },
  {
    id: 90, category: "Hotels", countryCity: "Bali", title: "Nandini Jungle by Hanging Gardens", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Bali-Nandini-Jungle.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236058&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F322852%3F",
    displayTitle: "Nandini Jungle by Hanging Gardens - Ubud",
    displayDescription: "Secluded jungle escape | Riverside villas & serene spa",
    description: "Secluded jungle escape | Riverside villas & serene spa",
    cta: "See Availability",
  },
  {
    id: 91, category: "Hotels", countryCity: "Bali", title: "The Box Paradise Bungalow", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Bali-the-box-paradise.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236059&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F88713%3F",
    displayTitle: "The Box Paradise Bungalow - Bali",
    displayDescription: "Cozy tropical bungalows | Relaxed island vibes near the beach",
    description: "Cozy tropical bungalows | Relaxed island vibes near the beach",
    cta: "See Availability",
  },
  {
    id: 92, category: "Hotels", countryCity: "Bali", title: "LaMeli Villas Ubud", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Bali-LaMeli-Villas.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236060&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F476156%3F",
    displayTitle: "LaMeli Villas - Ubud",
    displayDescription: "Private pool villas | Quiet luxury in lush surroundings",
    description: "Private pool villas | Quiet luxury in lush surroundings",
    cta: "See Availability",
  },
  {
    id: 93, category: "Hotels", countryCity: "Bali", title: "Hotel Vila Lumbung", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Bali-Hotel-Vila-Lumbung.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236061&k_site=https%3A%2F%2Fwww.klook.com%2Fen-GB%2Fhotels%2F256031%3F",
    displayTitle: "Hotel Vila Lumbung - Seminyak",
    displayDescription: "Balinese-style resort | Gardens, pools & Seminyak access",
    description: "Balinese-style resort | Gardens, pools & Seminyak access",
    cta: "See Availability",
  },
  {
    id: 94, category: "Hotels", countryCity: "Vietnam - Hanoi", title: "Hanoi Splendid Premium Hotel", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Vietnam-Hanoi-Splendid-Premium-Hotel.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236062&k_site=https%3A%2F%2Fwww.klook.com%2Fen-GB%2Fhotels%2F1772744%3F",
    displayTitle: "Hanoi Splendid Premium Hotel - Hanoi",
    displayDescription: "Old Quarter boutique stay | Close to Hanoi's cultural landmarks",
    description: "Old Quarter boutique stay | Close to Hanoi's cultural landmarks",
    cta: "See Availability",
  },
  {
    id: 95, category: "Hotels", countryCity: "Vietnam - Hanoi", title: "Wyndham Sky Lake Resorts and Villas", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Vietnam-Hanoi-Wyndham-Sky-Lake-Resorts.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236063&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F243246%3F",
    displayTitle: "Wyndham Sky Lake Resort & Villas - Hanoi",
    displayDescription: "Lakeside luxury retreat | Golf resort with scenic mountain views",
    description: "Lakeside luxury retreat | Golf resort with scenic mountain views",
    cta: "See Availability",
  },
  {
    id: 96, category: "Hotels", countryCity: "Vietnam - Da Nang", title: "Santorin HoiAn Villa", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Vietnam-Da-Nang-Santorin-HoiAn-Villa.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236064&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F13301%3F",
    displayTitle: "Santorin HoiAn Villa - Hoi An",
    displayDescription: "Santorini-style villa stay | Elegant rooms near Hoi An",
    description: "Santorini-style villa stay | Elegant rooms near Hoi An",
    cta: "See Availability",
  },
  {
    id: 97, category: "Hotels", countryCity: "Australia - Sydney", title: "The Lord Nelson Brewery Hotel", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Australia-Sydney-the-lord-nelson.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236065&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F532075%3F",
    displayTitle: "The Lord Nelson Brewery Hotel - Sydney",
    displayDescription: "Historic pub-style stay | Brewery experience near Harbour Bridge",
    description: "Historic pub-style stay | Brewery experience near Harbour Bridge",
    cta: "See Availability",
  },
  {
    id: 98, category: "Hotels", countryCity: "Azerbaijan - Baku", title: "Holiday Inn Baku by IHG", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Azerbaijan-Baku-Holiday-Inn.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236066&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F54027%3F",
    displayTitle: "Holiday Inn Baku by IHG - Baku",
    displayDescription: "Modern comfort in city center | Steps from Baku waterfront",
    description: "Modern comfort in city center | Steps from Baku waterfront",
    cta: "See Availability",
  },
  {
    id: 99, category: "Hotels", countryCity: "Dubai", title: "Stay Bridge Suites Dubai Financial Centre by IHG", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Dubai-Stay-Bridge-Suites.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236067&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F680230%3F",
    displayTitle: "Staybridge Suites Dubai Financial Centre - Dubai",
    displayDescription: "Spacious suites with skyline views | Near Burj Khalifa & DIFC",
    description: "Spacious suites with skyline views | Near Burj Khalifa & DIFC",
    cta: "See Availability",
  },
  // id 100 (Nova Skyland / Finland) is excluded (filtered out in original)
  {
    id: 101, category: "Hotels", countryCity: "Georgia - Tbilisi", title: "Jazz Hotel", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Georgia-Tbilisi-Jazz-Hotel.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236071&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F213306%3F",
    displayTitle: "Jazz Hotel - Tbilisi",
    displayDescription: "Stylish boutique stay | Cozy rooms near Tbilisi Old Town",
    description: "Stylish boutique stay | Cozy rooms near Tbilisi Old Town",
    cta: "See Availability",
  },
  {
    id: 102, category: "Hotels", countryCity: "Japan - Tokyo", title: "Sotetsu Fresa Inn Kanda Otemachi", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Japan-Tokyo-Sotetsu-Fresa-Inn-Kanda-Otemachi.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236072&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F741269%3F",
    displayTitle: "Sotetsu Fresa Inn Kanda Otemachi - Tokyo",
    displayDescription: "Modern business hotel | Easy access to Tokyo Station",
    description: "Modern business hotel | Easy access to Tokyo Station",
    cta: "See Availability",
  },
  {
    id: 103, category: "Hotels", countryCity: "Kazakhstan - Almaty", title: "Holiday Inn ALMATY by IHG", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Kazakhstan-Almaty-Holiday-Inn-ALMATY-by-IHG.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236074&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F70016%3F",
    displayTitle: "Holiday Inn Almaty by IHG - Almaty",
    displayDescription: "Comfort in the city center | Views of the Tian Shan mountains",
    description: "Comfort in the city center | Views of the Tian Shan mountains",
    cta: "See Availability",
  },
  {
    id: 104, category: "Hotels", countryCity: "Malaysia - Kuala Lumpur", title: "Neu Suites by Moonlight", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Malaysia-Kuala-Lumpur-Neu-Suites-by-Moonlight.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236076&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F1325806%3F",
    displayTitle: "Neu Suites by Moonlight - Kuala Lumpur",
    displayDescription: "Contemporary serviced suites | Skyline views near KLCC",
    description: "Contemporary serviced suites | Skyline views near KLCC",
    cta: "See Availability",
  },
  {
    id: 105, category: "Hotels", countryCity: "Singapore", title: "A Hotel Bugis", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Singapore-A-Hotel-Bugis.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236077&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F1712067%3F",
    displayTitle: "A Hotel Bugis - Singapore",
    displayDescription: "Budget-friendly city stay | Steps from Bugis shopping district",
    description: "Budget-friendly city stay | Steps from Bugis shopping district",
    cta: "See Availability",
  },
  {
    id: 106, category: "Hotels", countryCity: "Sri Lanka - Colombo", title: "Cinnamon Lakeside Colombo", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Sri-Lanka-Colombo-Cinnamon-Lakeside.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236078&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F248852%3F",
    displayTitle: "Cinnamon Lakeside Colombo - Colombo",
    displayDescription: "Lakeside luxury resort | City views with tranquil surroundings",
    description: "Lakeside luxury resort | City views with tranquil surroundings",
    cta: "See Availability",
  },
  {
    id: 107, category: "Hotels", countryCity: "Thailand - Pattaya", title: "LK Emerald Beach", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Thailand-Pattaya-LK-Emerald-Beach.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236082&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F148484%3F",
    displayTitle: "LK Emerald Beach - Pattaya",
    displayDescription: "Beachfront luxury stay | Elegant rooms with ocean views",
    description: "Beachfront luxury stay | Elegant rooms with ocean views",
    cta: "See Availability",
  },
  {
    id: 108, category: "Hotels", countryCity: "Thailand - Pattaya", title: "Bay Beach Resort Jomtien", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Thailand-Pattaya-Bay-Beach-Resort-Jomtien.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236083&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F577844%3F",
    displayTitle: "Bay Beach Resort Jomtien - Pattaya",
    displayDescription: "Beachfront stay in Jomtien | Sea views & relaxed coastal vibe",
    description: "Beachfront stay in Jomtien | Sea views & relaxed coastal vibe",
    cta: "See Availability",
  },
  {
    id: 109, category: "Hotels", countryCity: "Thailand - Pattaya", title: "April suites", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Thailand-Pattaya-April-suites.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236084&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F374770%3F",
    displayTitle: "April Suites - Pattaya",
    displayDescription: "Modern boutique stay | Rooftop pool near Pattaya Beach",
    description: "Modern boutique stay | Rooftop pool near Pattaya Beach",
    cta: "See Availability",
  },
  {
    id: 110, category: "Hotels", countryCity: "Thailand - Bangkok", title: "Bangkok City Rama 9 Hotel", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Thailand-Bangkok-City-Rama-9-Hotel.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236086&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F2169327%3F",
    displayTitle: "Bangkok City Rama 9 Hotel - Bangkok",
    displayDescription: "Comfortable city hotel | Close to shopping & MRT access",
    description: "Comfortable city hotel | Close to shopping & MRT access",
    cta: "See Availability",
  },
  {
    id: 111, category: "Hotels", countryCity: "Thailand - Bangkok", title: "Picnic Hotel Bangkok", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Thailand-Bangkok-Picnic-Hotel.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236087&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F279504%3F",
    displayTitle: "Picnic Hotel Bangkok - Bangkok",
    displayDescription: "Cozy stay near Victory Monument | Easy access to BTS",
    description: "Cozy stay near Victory Monument | Easy access to BTS",
    cta: "See Availability",
  },
  {
    id: 112, category: "Hotels", countryCity: "Thailand - Bangkok", title: "Ramada by Wyndham Bangkok Sukhumvit 87", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Thailand-Bangkok-Ramada-by-Wyndham.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236088&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F864248%3F",
    displayTitle: "Ramada by Wyndham Sukhumvit 87 - Bangkok",
    displayDescription: "International comfort | Stylish rooms near BTS On Nut",
    description: "International comfort | Stylish rooms near BTS On Nut",
    cta: "See Availability",
  },
  {
    id: 113, category: "Hotels", countryCity: "Thailand - Krabi", title: "GLOW Ao Nang Krabi", partner: "Klook",
    image: img("hotels", "Travel-Rethinkways-Hotels-Thailand-Krabi-GLOW-Ao-Nang-Krabi.avif"),
    coupon: "HOTEL25", discount: "25%",
    link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236089&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F436892%3F",
    displayTitle: "GLOW Ao Nang Krabi - Krabi",
    displayDescription: "Tropical getaway | Minutes from Ao Nang Beach",
    description: "Tropical getaway | Minutes from Ao Nang Beach",
    cta: "See Availability",
  },
  // ── FLIGHTS ─────────────────────────────────────────────────
  {
    id: 114, category: "Flights", countryCity: "India", title: "Trip.com Domestic Flights",
    image: img("flights", "Travel-Rethinkways-Flights-India-Destination.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://trip.tpo.lu/kPCD5XvU",
    displayTitle: "Zero Booking Fee - Domestic Flights",
    displayDescription: "No hidden charges | Perfect for family & group travel",
    description: "All India Flights Deal\nSmart Domestic Flight Fares\n\nZero Booking Fee • All Airlines Included",
    badgeText: "TOP OFFERS", liveTagText: "LIMITED TIME FARES", offerText: "LIMITED TIME FARES",
    validUntil: "LIVE FARE", audienceText: "Trending Searches",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 115, category: "Flights", countryCity: "Bali", title: "Chennai to Bali Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Bali.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/saZr4E13",
    displayTitle: "Chennai to Bali",
    displayDescription: "Island getaway deals | Perfect for honeymoon trips",
    description: "Escape to Bali's Beauty\nChennai (MAA) → Bali (DPS)\n\nRound Trip • 1 Stop\nLowest fares for May - June travel\n\n120+ people searched today",
    badgeText: "TODAY'S DEAL", liveTagText: "BEST PRICE TODAY", offerText: "BEST PRICE TODAY",
    validUntil: "LIVE FARE", audienceText: "120+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 116, category: "Flights", countryCity: "Bali", title: "Delhi to Bali Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Bali Airlines.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/zJ20HYJZ",
    displayTitle: "Delhi to Bali",
    displayDescription: "Island paradise escape | Popular honeymoon route",
    description: "Escape to Bali's Beauty\nDelhi (DEL) → Bali (DPS)\n\nRound Trip • 1 Stop\nLowest fares for May - June travel\n\n180+ people searched today",
    badgeText: "HOT DEAL", liveTagText: "TODAY'S BEST DEALS", offerText: "TODAY'S BEST DEALS",
    validUntil: "LIVE FARE", audienceText: "190+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 117, category: "Flights", countryCity: "Male - Maldives", title: "Chennai to Male Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Maldives.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/GFYt1JrS",
    displayTitle: "Chennai to Malé (Maldives)",
    displayDescription: "Quick island escape | Direct flights to paradise",
    description: "Luxury Island Escape\nChennai (MAA) → Malé (MLE)\n\nRound Trip • 1 Stop\nLowest fares for May - June travel\n\n140+ people searched today",
    badgeText: "EXCLUSIVE FARE", liveTagText: "HOT FARE PICKS", offerText: "HOT FARE PICKS",
    validUntil: "LIVE FARE", audienceText: "140+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 118, category: "Flights", countryCity: "Bangkok", title: "Chennai to Bangkok Flights",
    image: img("flights", "Travel-Rethinkways-Flights-bangkok.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/lzHZX8X3",
    displayTitle: "Chennai to Bangkok",
    displayDescription: "Budget-friendly Southeast Asia trip | Great weekend getaway",
    description: "Fun City Escape\nChennai (MAA) → Bangkok (BKK)\n\nRound Trip • Non-stop\nLowest fares for May - June travel\n\n210+ people searched today",
    badgeText: "HOT DEAL", liveTagText: "CURATED FARE DEALS", offerText: "CURATED FARE DEALS",
    validUntil: "LIVE FARE", audienceText: "220+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 119, category: "Flights", countryCity: "Phuket", title: "Chennai to Phuket Flights",
    image: img("flights", "Travel-Rethinkways-Flights-phuket.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/wQewXYyT",
    displayTitle: "Chennai to Phuket",
    displayDescription: "Beach holiday hotspot | Great budget fares",
    description: "Escape to Phuket's Beaches\nChennai (MAA) → Phuket (HKT)\n\nRound Trip • Non-stop\nLowest fares for May - June travel\n\n180+ people searched today",
    badgeText: "TRENDING", liveTagText: "ISLAND FARE DEALS", offerText: "ISLAND FARE DEALS",
    validUntil: "LIVE FARE", audienceText: "180+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 120, category: "Flights", countryCity: "Kuala Lumpur", title: "Chennai to Kuala Lumpur Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Kuala lumpur.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/ZNTHMcX9",
    displayTitle: "Chennai to Kuala Lumpur",
    displayDescription: "Affordable city break | Direct flights available",
    description: "Discover Kuala Lumpur's Skyline\nChennai (MAA) → Kuala Lumpur (KUL)\n\nRound Trip • Non-stop\nLowest fares for May - June travel\n\n230+ people searched today",
    badgeText: "HOT SELLING", liveTagText: "TROPICAL FARE PICKS", offerText: "TROPICAL FARE PICKS",
    validUntil: "LIVE FARE", audienceText: "230+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 121, category: "Flights", countryCity: "Singapore", title: "Chennai to Singapore Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Singapore.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/FsU252W2",
    displayTitle: "Chennai to Singapore",
    displayDescription: "Short international escape | Nonstop flights available",
    description: "Experience Singapore's City Life\nChennai (MAA) → Singapore (SIN)\n\nRound Trip • Non-stop\nBest time to fly: May - June\n\n190+ people searched today",
    badgeText: "EXCLUSIVE FARE", liveTagText: "URBAN ESCAPE DEALS", offerText: "URBAN ESCAPE DEALS",
    validUntil: "LIVE FARE", audienceText: "190+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 122, category: "Flights", countryCity: "Dubai", title: "Chennai to Dubai Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Dubai.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/aYtnjWm9",
    displayTitle: "Chennai to Dubai",
    displayDescription: "Popular Gulf route | Multiple daily flights",
    description: "Discover Dubai's Luxury\nChennai (MAA) → Dubai (DXB)\n\nRound Trip • Non-stop\nLowest fares for May - June travel\n\n250+ people searched today",
    badgeText: "EXCLUSIVE FARE", liveTagText: "PREMIUM FARE DEALS", offerText: "PREMIUM FARE DEALS",
    validUntil: "LIVE FARE", audienceText: "250+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 123, category: "Flights", countryCity: "Ho Chi Minh City", title: "Chennai to Ho Chi Minh City Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Ho Chi Minh-City.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/nthUy72l",
    displayTitle: "Chennai to Ho Chi Minh City",
    displayDescription: "Rising Vietnam destination | Budget flight options",
    description: "Explore Vietnam's Vibrant Streets\nChennai (MAA) → Ho Chi Minh City (SGN)\n\nRound Trip • 1 Stop\nLowest fares for May - June travel\n\n160+ people searched today",
    badgeText: "TRENDING", liveTagText: "VALUE FARE PICKS", offerText: "VALUE FARE PICKS",
    validUntil: "LIVE FARE", audienceText: "160+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 124, category: "Flights", countryCity: "Tokyo", title: "Chennai to Tokyo Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Tokyo.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/JNnUKeEE",
    displayTitle: "Chennai to Tokyo",
    displayDescription: "Long-haul Asia adventure | Seasonal flight deals",
    description: "Experience Tokyo's Timeless Culture\nChennai (MAA) → Tokyo (HND)\n\nRound Trip • 1 Stop\nLowest fares for June - July travel\n\n120+ people searched today",
    badgeText: "EXCLUSIVE FARE", liveTagText: "LUXURY FARE DEALS", offerText: "LUXURY FARE DEALS",
    validUntil: "LIVE FARE", audienceText: "120+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 125, category: "Flights", countryCity: "London", title: "Chennai to London Flights",
    image: img("flights", "Travel-Rethinkways-Flights-London.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/PNQKvZPp",
    displayTitle: "Chennai to London",
    displayDescription: "Popular Europe route | Compare multiple airlines",
    description: "Discover London's Iconic Landmarks\nChennai (MAA) → London (LHR)\n\nRound Trip • Non-stop\nLowest fares for May - July travel\n\n140+ people searched today",
    badgeText: "EXCLUSIVE FARE", liveTagText: "LONG HAUL DEALS", offerText: "LONG HAUL DEALS",
    validUntil: "LIVE FARE", audienceText: "140+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 126, category: "Flights", countryCity: "Hong Kong", title: "Chennai to Hong Kong Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Hong Kong.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/UU7QT8lh",
    displayTitle: "Chennai to Hong Kong",
    displayDescription: "Asia's vibrant skyline city | Frequent airline options",
    description: "Experience Hong Kong's Skyline\nChennai (MAA) → Hong Kong (HKG)\n\nRound Trip • Non-stop\nLowest fares for May - June travel\n\n160+ people searched today",
    badgeText: "TRENDING", liveTagText: "BEST PRICE TODAY", offerText: "BEST PRICE TODAY",
    validUntil: "LIVE FARE", audienceText: "160+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 127, category: "Flights", countryCity: "Seoul", title: "Chennai to Seoul Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Seoul.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/P3NZZGNG",
    displayTitle: "Chennai to Seoul",
    displayDescription: "K-culture capital | Growing travel demand",
    description: "Explore Seoul's Trending Culture\nChennai (MAA) → Seoul (ICN)\n\nRound Trip • 1 Stop\nLowest fares for June - July travel\n\n130+ people searched today",
    badgeText: "EXCLUSIVE FARE", liveTagText: "TRENDING FARE DEALS", offerText: "TRENDING FARE DEALS",
    validUntil: "LIVE FARE", audienceText: "130+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 128, category: "Flights", countryCity: "Paris", title: "Chennai to Paris Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Paris.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/dPKbOdw9",
    displayTitle: "Chennai to Paris",
    displayDescription: "Romantic Europe escape | Compare multiple airlines",
    description: "Experience Parisian Elegance\nChennai (MAA) → Paris (CDG)\n\nRound Trip • 1 Stop\nBest fares for May - July travel\n\n150+ people searched today",
    badgeText: "HOT DEAL", liveTagText: "EUROPE FARE DEALS", offerText: "EUROPE FARE DEALS",
    validUntil: "LIVE FARE", audienceText: "150+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 129, category: "Flights", countryCity: "Rome", title: "Chennai to Rome Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Rome.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/rmZLSnRK",
    displayTitle: "Chennai to Rome",
    displayDescription: "Historic European getaway | Seasonal fare deals",
    description: "Explore Rome's Historic Wonders\nChennai (MAA) → Rome (FCO)\n\nRound Trip • 1 Stop\nGreat fares available for May - July\n\n120+ people searched today",
    badgeText: "EXCLUSIVE FARE", liveTagText: "CLASSIC EUROPE FARE", offerText: "CLASSIC EUROPE FARE",
    validUntil: "LIVE FARE", audienceText: "120+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 130, category: "Flights", countryCity: "Istanbul", title: "Chennai to Istanbul Flights",
    image: img("flights", "Travel-Rethinkways-Flights-istanbul.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/Ndsl0qGu",
    displayTitle: "Chennai to Istanbul",
    displayDescription: "Bridge of Europe & Asia | Popular transit hub",
    description: "Discover Istanbul's Cultural Charm\nChennai (MAA) → Istanbul (IST)\n\nRound Trip • 1 Stop\nLowest fares for May - June travel\n\n190+ people searched today",
    badgeText: "EXCLUSIVE FARE", liveTagText: "CULTURAL FARE DEALS", offerText: "CULTURAL FARE DEALS",
    validUntil: "LIVE FARE", audienceText: "190+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 131, category: "Flights", countryCity: "Baku", title: "Chennai to Baku Flights",
    image: img("flights", "Travel-Rethinkways-Flights-baku.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/9OA5N4pG",
    displayTitle: "Chennai to Baku",
    displayDescription: "Caspian Sea city break | Rising travel trend",
    description: "Explore Baku's Modern & Old City\nChennai (MAA) → Baku (GYD)\n\nRound Trip • 1 Stop\nSave more on May - June travel\n\n170+ people searched today",
    badgeText: "BEST VALUE", liveTagText: "BUDGET FARE DEALS", offerText: "BUDGET FARE DEALS",
    validUntil: "LIVE FARE", audienceText: "170+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 132, category: "Flights", countryCity: "Tbilisi", title: "Chennai to Tbilisi Flights",
    image: img("flights", "Travel-Rethinkways-Flights-tbilisi.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/DlIkrqEF",
    displayTitle: "Chennai to Tbilisi",
    displayDescription: "Emerging Europe destination | Budget travel hotspot",
    description: "Discover Tbilisi's Hidden Charm\nChennai (MAA) → Tbilisi (TBS)\n\nRound Trip • 1 Stop\nBest fares for May - June travel\n\n140+ people searched today",
    badgeText: "TRENDING", liveTagText: "OFFBEAT FARE DEALS", offerText: "OFFBEAT FARE DEALS",
    validUntil: "LIVE FARE", audienceText: "140+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
  {
    id: 133, category: "Flights", countryCity: "Hanoi", title: "Chennai to Hanoi Flights",
    image: img("flights", "Travel-Rethinkways-Flights-Hanoi.avif"),
    coupon: "FLIGHTS25", discount: "25%",
    link: "https://booking.tpo.lu/c8yCq0gF",
    displayTitle: "Chennai to Hanoi",
    displayDescription: "Gateway to Vietnam's cultural capital | Affordable Southeast Asia flights",
    description: "Experience Hanoi's Cultural Vibes\nChennai (MAA) → Hanoi (HAN)\n\nRound Trip • 1 Stop\nGreat fares available for May - June\n\n200+ people searched today",
    badgeText: "HOT DEAL", liveTagText: "VALUE FARE DEALS", offerText: "VALUE FARE DEALS",
    validUntil: "LIVE FARE", audienceText: "200+ people searched today",
    primaryCta: "Check Price", secondaryCta: "Talk to Expert", cta: "Check Price",
  },
];

// ─────────────────────────────────────────────────────────────
// ATTRACTION OVERRIDES (merged on top of seed data)
// ─────────────────────────────────────────────────────────────

const ATTRACTION_DEFAULTS = {
  partner: "Klook",
  liveTagText: "LIVE NOW",
  offerText: "",
  validUntil: "",
  audienceText: "",
  primaryCta: "View Deal",
  secondaryCta: "Plan Your Visit",
};

const ATTRACTION_OVERRIDES = {
  26: { countryCity: "Bali", displayTitle: "Mount Batur Sunrise Jeep Tour", displayDescription: "Epic sunrise above Bali's volcano | Jeep ride & trekking adventure", description: "Mount Batur Sunrise Jeep Tour\n\n2–3 Hours • Early Morning\nSunrise View • Jeep Ride • Volcano Experience\nIncludes: Guide • Transfers • Sightseeings", badgeText: "Bestseller", priceTagText: "From ₹1,171" },
  27: { countryCity: "Bali", displayTitle: "Snorkeling Experience in Nusa Penida", displayDescription: "Swim with vibrant marine life | Crystal-clear waters & coral reefs", description: "Snorkeling in Nusa Penida\n\n2 Hours\nCoral Reefs • Marine Life • Crystal-clear Water\nIncludes: Hotel Pickup & Drop | Get 20% Off Selected Packages\n\nValid Till: 15th July 2026", badgeText: "Top Rated", priceTagText: "From ₹738", validUntil: "15th July 2026" },
  28: { countryCity: "Bali", displayTitle: "Bali ATV Ride & Ayung River Rafting", displayDescription: "Jungle ATV trails & thrilling white-water rafting | Adventure with lunch", description: "Bali ATV Ride & River Rafting\n\nFull Day Adventure\nATV Trails • White Water Rafting\n\nIncludes: Hotel Pickup & Drop", badgeText: "Must Try", priceTagText: "From ₹1,727" },
  29: { countryCity: "Bali", displayTitle: "Uluwatu Temple Kecak & Fire Dance Show", displayDescription: "Epic sunset views & traditional Balinese fire dance performance", description: "Uluwatu Temple Kecak & Fire Dance Show\n\n2–3 Hours • Evening Experience  | Get 5% Offer\nCliffside Sunset • Traditional Kecak Dance • Fire Show\n\nValid Till: 15th July 2026", badgeText: "Bestseller", priceTagText: "From ₹742", validUntil: "15th July 2026" },
  30: { countryCity: "Bali", displayTitle: "Bali Safari Park Ticket", displayDescription: "Wildlife encounters & safari adventure | See animals up close", description: "Bali Safari Park Entry Ticket\n\nHalf Day Experience  | Get 2% offer\nWildlife Safari • Animal Shows • Family-friendly\n\nValid till: 1st May 2026", badgeText: "Top Rated", priceTagText: "From ₹2,816", validUntil: "1st May 2026" },
  31: { countryCity: "Bali", displayTitle: "Waterbom Bali Ticket", displayDescription: "Asia's top waterpark thrills | Slides, pools & tropical fun", description: "Waterbom Bali Water Park Ticket\n\nFull Day Access  | Lowest Season Offers Available\nThrilling Slides • Lazy River • Family Fun", badgeText: "Must Try", priceTagText: "From ₹3,034" },
  32: { countryCity: "Bali", displayTitle: "Lovina Dolphin Watching & Snorkeling Tour", displayDescription: "Sunrise dolphin spotting & reef snorkeling | A magical experience", description: "Lovina Dolphin Watching & Snorkeling Tour\n\nHalf Day • Early Morning\nDolphin Spotting • Snorkeling • Boat Ride", badgeText: "Unique Experience", priceTagText: "From ₹587" },
  33: { countryCity: "Bali", displayTitle: "Garuda Wisnu Kencana Cultural Park Ticket", displayDescription: "Home to Bali's giant statue | Culture, views & iconic landmarks", description: "Garuda Wisnu Kencana Cultural Park Ticket\n\n2–3 Hours • Flexible Visit\nGWK Statue • Barong Show 30 mins • Scenic Views", badgeText: "Must Visit", priceTagText: "From ₹691" },
  34: { countryCity: "Vietnam - Hanoi", displayTitle: "Lotte World Aquarium Hanoi Ticket", displayDescription: "Explore thousands of marine creatures | Walk through ocean tunnels", description: "Lotte World Aquarium Hanoi Ticket\n\n2–3 Hours  | Get 15% off selected packages\nMarine Exhibits • Interactive Zones • Family-friendly\n\nValid Till: 29 June 2026", badgeText: "Family Favourite", priceTagText: "From ₹842", validUntil: "29 June 2026" },
  35: { countryCity: "Vietnam - Hanoi", displayTitle: "Thang Long Water Puppet Show Ticket", displayDescription: "Traditional Vietnamese storytelling on water | Live music & cultural performance", description: "Thang Long Water Puppet Show Ticket\n\n50 minutes • Evening Show\nTraditional Performance • Live Music • Local Art", badgeText: "Cultural Experience", priceTagText: "From ₹425" },
  36: { countryCity: "Vietnam - Ha Long Bay", displayTitle: "Ambassador Day Cruise - Ha Long Bay", displayDescription: "Luxury cruise through limestone islands | Visit Sung Sot Cave & Ti Top Island", description: "Ha Long Bay Ambassador Day Cruise\n\nFull Day Experience  | Get 10% off selected packages\nLuxury Cruise • Limestone Caves • Buffet Lunch\n\nValid Till: 31st Dec 2026", badgeText: "Premium Experience", priceTagText: "From ₹5,808", validUntil: "31st Dec 2026" },
  37: { countryCity: "Vietnam - Ho Chi Minh", displayTitle: "Cu Chi Tunnels & Mekong Delta Luxury Day Tour", displayDescription: "Historic tunnels & river landscapes | Vietnam's wartime history experience", description: "Cu Chi Tunnels & Mekong Delta Luxury Tour\n\nFull Day Experience  | Get 15% off selected packages\nHistoric tunnels • River cruise • Local village visit\n\nIncludes: Transfers | Lunch | Guided Tour\n\nValid Till: 31st Dec 2026", badgeText: "Bestseller", priceTagText: "From ₹2,926", validUntil: "31st Dec 2026" },
  38: { countryCity: "Vietnam - Phu Quoc", displayTitle: "VinWonders Phu Quoc Ticket", displayDescription: "Thrilling rides & water park fun | Vietnam's largest theme park", description: "VinWonders Phu Quoc Theme Park Ticket\n\nFull Day Access  | Package Options Available\nTheme Park Rides • Water Park • Family Fun", badgeText: "Must Try", priceTagText: "From ₹562" },
  39: { countryCity: "Vietnam - Hoi An", displayTitle: "Coconut Forest Basket Boat Ride - Hoi An", displayDescription: "Spin through palm canals | Unique basket boat adventure", description: "Hoi An Coconut Forest Basket Boat Ride\n\n1–2 Hours\nBasket Boat Ride • Coconut Forest • Local Performance", badgeText: "Unique Experience", priceTagText: "From ₹302" },
  40: { countryCity: "Thailand - Pattaya", displayTitle: "Elephant Jungle Sanctuary Pattaya Experience", displayDescription: "Ethical elephant encounters | Feed, bathe & learn about them", description: "Elephant Jungle Sanctuary Pattaya Experience\n\n1-3 Hours\nElephant Interaction • Feeding • Ethical Sanctuary Visit\n\nIncludes: Transfers | Guided Tour | Eco-friendly Workshop", badgeText: "Top Rated", priceTagText: "From ₹2,336" },
  41: { countryCity: "Thailand - Pattaya", displayTitle: "Pattaya Floating Market Ticket", displayDescription: "Traditional market on water | Boats, food & local culture", description: "Pattaya Floating Market Entry Ticket\n\n2–3 Hours\nLocal Shopping • Cultural Shows • Food Experience", badgeText: "Must Visit", priceTagText: "From ₹346" },
  42: { countryCity: "Thailand - Pattaya", displayTitle: "Alcazar Cabaret Pattaya Ticket", displayDescription: "Dazzling costumes & stage performances | Thailand's iconic cabaret show", description: "Alcazar Cabaret Show Pattaya Ticket\n\n1–1.5 Hours • Evening Show\nCabaret Performance • Music • Dance show\n\nIncludes: VIP Ticket | Seat Plan", badgeText: "Hot Selling", priceTagText: "From ₹2,595" },
  43: { countryCity: "Thailand - Bangkok", displayTitle: "Safari World Bangkok Ticket", displayDescription: "Open zoo safari adventure | Wildlife shows & animal encounters", description: "Safari World Bangkok Ticket\n\nFull Day Experience\nSafari Drive • Marine Park • Animal Shows", badgeText: "Bestseller", priceTagText: "From ₹2,797" },
  44: { countryCity: "Thailand - Bangkok", displayTitle: "Chao Phraya Princess Cruise - Bangkok", displayDescription: "Dinner cruise with city skyline views | Live music on the river", description: "Chao Phraya Princess Dinner Cruise\n\n2–3 Hours • Evening • Package Options Available\nRiver Cruise • Buffet Dinner • Live Music\n\nIncludes: Meals & Beverages | English Speaking Staff | Free Birthday Cake", badgeText: "Premium Experience", priceTagText: "From ₹2,451" },
  45: { countryCity: "Thailand - Bangkok", displayTitle: "Bangkok Grand Palace & Emerald Buddha Ticket", displayDescription: "Thailand's most sacred temple complex | Royal heritage & stunning architecture", description: "Bangkok Grand Palace & Emerald Buddha Ticket\n\n2–3 Hours  | Shuttle Service Available\nRoyal Palace • Sacred Temple • Cultural Landmark", badgeText: "Must Visit", priceTagText: "From ₹1,874" },
  46: { countryCity: "Malaysia - Kuala Lumpur", displayTitle: "Sunway Lagoon Ticket", displayDescription: "Water rides & theme park thrills | One of Malaysia's top parks", description: "Sunway Lagoon Theme Park Ticket\n\nFull Day Access  | Express Lane Pass\nWater Park • Adventure Rides • Wildlife Park", badgeText: "Must Try", priceTagText: "From ₹1,875" },
  47: { countryCity: "Malaysia - Kuala Lumpur", displayTitle: "Petronas Twin Towers Ticket", displayDescription: "Skybridge views above Kuala Lumpur | Visit the iconic twin towers", description: "Petronas Twin Towers Skybridge Ticket\n\n1–2 Hours\nSkybridge Access • City Skyline Views • Observation Deck", badgeText: "Hot Selling", priceTagText: "From ₹1,119" },
  48: { countryCity: "Malaysia - Kuala Lumpur", displayTitle: "Genting Highlands Tour with Awana Cable Car", displayDescription: "Cool mountain escape | Scenic cable car & outlet shopping", description: "Genting Highlands Tour with Awana Cable Car\n\nHalf Day Experience  | Guided Tour\nCable Car Ride • Mountain Views • Casino & Shopping", badgeText: "Scenic Experience", priceTagText: "From ₹2,276" },
  49: { countryCity: "Malaysia - Langkawi", displayTitle: "Langkawi Cable Car Ticket", displayDescription: "Ride above rainforest peaks | Stunning views from SkyCab", description: "Langkawi Cable Car & Sky Bridge Ticket\n\n2–3 Hours  | Get 5% Off on Combo Packages\nCable car ride • Sky bridge • Panoramic island views", badgeText: "Top Rated", priceTagText: "From ₹926" },
  50: { countryCity: "Malaysia - Langkawi", displayTitle: "Langkawi VIP 5-in-1 Island Hopping Tour", displayDescription: "Explore hidden islands | Beaches, eagles & crystal waters", description: "Langkawi VIP 5-in-1 Island Hopping Tour\n\nHalf Day Experience\nIsland Hopping • Eagle Feeding • Snorkeling • Beach Stops\n\nIncludes: English Speaking Guide | Lunch | Beverages", badgeText: "Premium Experience", priceTagText: "From ₹4,046" },
  51: { countryCity: "Sri Lanka - Colombo", displayTitle: "Sigiriya Lion's Rock Fortress Day Tour & Village Experience", displayDescription: "Climb the ancient rock citadel | Village life & cultural experience", description: "Sigiriya Lion Rock & Village Experience\n\nFull Day Tour\nSigiriya Climb • Village Tour • Cultural Experience\n\nIncludes: Hotel Pickup | Cooking Class | Fishing Boat Ride", badgeText: "Bestseller", priceTagText: "From ₹13,369" },
  52: { countryCity: "Sri Lanka - Colombo", displayTitle: "Ella Nine Arches Bridge & Little Adam's Peak Tour", displayDescription: "Iconic railway bridge views | Scenic hike in Ella hills", description: "Ella Nine Arches Bridge & Little Adam's Peak Tour\n\nHalf Day Experience  | 14+ Departure cities\nNine Arches Bridge • Little Adam's Peak • Scenic Viewpoints\n\nIncludes: Hotel Pickup | Guided Tour", badgeText: "Must Visit", priceTagText: "From ₹11,981" },
  53: { countryCity: "Sri Lanka - Colombo", displayTitle: "Udawalawe National Park Safari Experience", displayDescription: "Wild elephant sightings | Jeep safari through open grasslands", description: "Ella Highlights & Udawalawe Safari Tour\n\nFull Day Experience\nNine Arches Bridge • Little Adam's Peak • Wildlife Safari\n\nIncludes: Hotel Pick-up & Drop | Breakfast | Sightseeings", badgeText: "Adventure Combo", priceTagText: "From ₹5,222" },
  54: { countryCity: "Singapore", displayTitle: "Universal Studios Singapore Ticket", displayDescription: "Hollywood movie rides & attractions | Thrills for all ages", description: "Universal Studios Singapore Ticket\n\nFull Day Access  | Get 19% on Selected Products\nThrilling Rides • Family Entertainment • Free Vouchers", badgeText: "Hot Selling", priceTagText: "From ₹5,063" },
  55: { countryCity: "Singapore", displayTitle: "Gardens by the Bay Ticket", displayDescription: "Futuristic gardens & Supertrees | Nature meets innovation", description: "Gardens by the Bay Ticket\n\n2–3 Hours\nFloral Fantasy | My Little Pony | Supertree", badgeText: "Must Visit", priceTagText: "From ₹895" },
  56: { countryCity: "Singapore", displayTitle: "Night Safari Ticket - Mandai Wildlife Reserve", displayDescription: "World's first nocturnal zoo | Wildlife adventure after dark", description: "Night Safari – Mandai Wildlife Reserve\n\n2–3 Hours • Evening\nNight Wildlife • Tram Ride • Animal Encounters", badgeText: "Bestseller", priceTagText: "From ₹4,240" },
  57: { countryCity: "Singapore", displayTitle: "Wings of Time Fireworks Symphony Ticket", displayDescription: "Lights, lasers & fireworks show | Magical night by the sea", description: "Wings of Time Fireworks Symphony\n\n30–45 Min • Evening Show  | Get 20% off Selected Packages\nFireworks • Water show • Laser effects\n\nValid Till: 31st December 2026", badgeText: "Unique Experience", priceTagText: "From ₹1,137", validUntil: "31st December 2026" },
  58: { countryCity: "Singapore", displayTitle: "Marina Bay Sands SkyPark Observation Deck Ticket", displayDescription: "Sky-high city views | Iconic rooftop observation deck", description: "Marina Bay Sands SkyPark Observation Deck\n\n1–2 Hours  | Get 5% off Selected Packages\nSkyline Views • Infinity Deck • Photo Spots", badgeText: "Top Rated", priceTagText: "From ₹2,472" },
  59: { countryCity: "Dubai", displayTitle: "Museum of the Future Ticket - Dubai", displayDescription: "Step into tomorrow's innovations | Futuristic exhibits & immersive technology", description: "Museum of the Future Ticket – Dubai\n\n1–2 Hours\nInteractive Exhibits • Future Tech • Immersive Zones", badgeText: "Futuristic Experience", priceTagText: "From ₹4,353" },
  60: { countryCity: "Dubai", displayTitle: "Dubai Miracle Garden Ticket", displayDescription: "World's largest flower garden | Millions of blooms in stunning designs", description: "Dubai Miracle Garden Ticket\n\n2–3 Hours  | Get 17% on Combo Packs\nFloral Displays • Themed Gardens • Photo Spots", badgeText: "Seasonal Favourite", priceTagText: "From ₹1,861" },
  61: { countryCity: "Dubai", displayTitle: "Dubai Marina Dhow Cruise", displayDescription: "Dinner cruise with skyline views | Traditional dhow on Dubai Marina", description: "Dubai Marina Dhow Dinner Cruise\n\n2–3 Hours • Evening  | Get 30% off Selected Packages\nCruise • Buffet Dinner • Live Entertainment", badgeText: "Premium Experience", priceTagText: "From ₹1,545" },
  62: { countryCity: "Dubai", displayTitle: "Burj Khalifa - At The Top Ticket", displayDescription: "Views from the world's tallest tower | Iconic Dubai skyline experience", description: "Burj Khalifa Sunrise Admission Ticket\n\n1–2 Hours  | Get 13% Off on Combo Packs\nObservation deck • Skyline views • Iconic landmark\n\nIncludes: Free 1 eSIM | Cafe Treats | Mobile Audio Guide", badgeText: "Must Visit", priceTagText: "From ₹4,055" },
  63: { countryCity: "Australia - Sydney", displayTitle: "Sydney Opera House Tour & Dine Experience", displayDescription: "Explore Australia's iconic landmark | Guided tour with dining experience", description: "Sydney Opera House Tour & Dine\n\n2–3 Hours\nGuided tour • Dining Experience • Iconic Landmark", badgeText: "Premium Experience", priceTagText: "From ₹2,435" },
  64: { countryCity: "Azerbaijan - Baku", displayTitle: "Gobustan, Mud Volcanoes & Fire Temple Tour - Baku", displayDescription: "Ancient rock carvings & mud volcanoes | Azerbaijan's natural wonders", description: "Gobustan, Mud Volcano & Fire Temple Tour\n\nHalf Day Experience\nMud Volcanoes • Fire Temple • Rock Art\n\nIncludes: English Speaking Guide| Round Trip Transfers", badgeText: "Trending", priceTagText: "From ₹1,892" },
  65: { countryCity: "Azerbaijan - Baku", displayTitle: "Baku Old City Cultural Walking Tour", displayDescription: "Historic streets & medieval landmarks | Discover UNESCO-listed Old City", description: "Baku Old City Walking Tour\n\n2–3 Hours  | Guided Tour\nHistoric Streets • Landmarks • Local Stories", badgeText: "Cultural Experience", priceTagText: "From ₹1,203" },
  66: { countryCity: "Europe - Paris", displayTitle: "Disneyland Paris Theme Park Ticket", displayDescription: "Fairytale rides & Disney magic | Europe's most magical theme park", description: "Disneyland Paris Theme Park Ticket\n\nFull Day Access\nRides • Shows • Disney characters", badgeText: "Hot Selling", priceTagText: "From ₹5,656" },
  67: { countryCity: "Europe - Amsterdam", displayTitle: "Amsterdam Canal Cruise Experience", displayDescription: "Scenic cruise through historic canals | Iconic views of Amsterdam", description: "Amsterdam Canal Cruise\n\n1–2 Hours  | Get 40% off selected packages\nCity Canals • Scenic Views • Audio Guide", badgeText: "Classic Experience", priceTagText: "From ₹1,348" },
  68: { countryCity: "Europe - Amsterdam", displayTitle: "Eurail Global Pass", displayDescription: "Unlimited train travel across Europe | Explore multiple countries easily", description: "Eurail Global Train Pass\n\nFlexible Duration | Get 15% off selected packages\nUnlimited Train Travel Multi-country Access\n\nValid Till: 15th July 2026", badgeText: "Travel Essential", priceTagText: "From ₹26,304", validUntil: "15th July 2026" },
  69: { countryCity: "Europe - London", displayTitle: "Warner Bros. Studio Tour London - Harry Potter", displayDescription: "Step into the wizarding world | Behind the scenes of Hogwarts", description: "Warner Bros Studio Tour London – Harry Potter\n\nHalf Day Experience  | Get 10% off selected packages\nMovie Sets • Props • Behind-the-scenes\n\nValid Till: 30 Nov 2026", badgeText: "Must Visit", priceTagText: "From ₹4,739", validUntil: "30 Nov 2026" },
  70: { countryCity: "Europe - London", displayTitle: "Buckingham Palace, Big Ben & Westminster Abbey Tour", displayDescription: "Royal landmarks & historic sights | Discover London's iconic trio", description: "London Landmarks Tour\n\nHalf Day  | Guided Tour\nBuckingham Palace • Big Ben • Westminster Abbey", badgeText: "Value Deal", priceTagText: "From ₹9,378" },
  71: { countryCity: "Georgia - Tbilisi", displayTitle: "Kakheti Wine Region Tour - Tbilisi", displayDescription: "Georgia's famous wine country | Vineyards, tastings & scenic landscapes", description: "Kakheti Wine Region Tour – Tbilisi\n\nFull Day Experience\nWine Tasting • Vineyards • Scenic Countryside\n\nIncludes: Round-Trip Transfers | English Speaking Guide", badgeText: "Premium Experience", priceTagText: "From ₹3,910" },
  72: { countryCity: "Georgia - Tbilisi", displayTitle: "Tbilisi Hop-On Hop-Off City Tour", displayDescription: "Explore the city at your pace | 12 stops across major attractions", description: "Tbilisi Hop-On Hop-Off City Tour\n\nFlexible Duration\nCity Sightseeing • Multiple Stops • Audio Guide", badgeText: "Easy Explore", priceTagText: "From ₹1,640" },
  73: { countryCity: "Japan - Tokyo", displayTitle: "Shibuya Sky Ticket - Tokyo", displayDescription: "Open-air rooftop views | Tokyo skyline from above Shibuya", description: "Shibuya Sky Observation Deck Ticket\n\n1–2 Hours\nSky Views • City Skyline • Photo Spots", badgeText: "Trending", priceTagText: "From ₹1,655" },
  74: { countryCity: "Japan - Kyoto", displayTitle: "Kyoto, Arashiyama, Fushimi Inari & Nara Tour", displayDescription: "Temples, bamboo forest & friendly deer | Kyoto region highlights", description: "Kyoto, Arashiyama, Fushimi Inari & Nara Tour\n\nFull Day Experience  |Get 40% Off Selected Packages\nShrines • Bamboo Forest • Deer Park\n\nIncludes: Round-Trip Transfers | English Speaking Driver", badgeText: "Cultural Experience", priceTagText: "From ₹3,850" },
  75: { countryCity: "Turkey - Istanbul", displayTitle: "Istanbul Tourist Pass - 100+ Attractions", displayDescription: "Skip lines at top landmarks | One pass for Istanbul highlights", description: "Istanbul Tourist Pass – 100+ Attractions\n\nFlexible Duration\nMultiple Attractions • Skip-the-line • Guided Tours", badgeText: "Value Deal", priceTagText: "From ₹15,200" },
  76: { countryCity: "Turkey - Cappadocia", displayTitle: "Cappadocia Sunrise Hot Air Balloon Flight", displayDescription: "Float above fairy chimneys | Sunrise views with champagne toast", description: "Cappadocia Sunrise Hot Air Balloon Flight\n\n1–2 Hours • Early Morning\nBalloon Ride • Sunrise Views • Scenic Landscapes\n\nIncludes: Round-trip Transfers | Refreshments | Champagne Ceremony", badgeText: "Bucket List Experience", priceTagText: "From ₹8,512" },
  77: { countryCity: "South Korea - Seoul", displayTitle: "Nami Island, Alpaca & Rail Bike Tour - Seoul", displayDescription: "Cherry blossom scenery | Rail bike ride & alpaca encounters", description: "Nami Island, Alpaca & Rail Bike Tour\n\nFull Day Experience  | Get 30% off Selected Packages\nIsland Visit • Alpaca Farm • Rail Biking\n\nValid Till: 15th July 2026", badgeText: "Bestseller", priceTagText: "From ₹2,643", validUntil: "15th July 2026" },
  78: { countryCity: "South Korea - Seoul", displayTitle: "Seoul Sky - Lotte World Tower Ticket", displayDescription: "Sky-high views from Korea's tallest tower | Seoul skyline panorama", description: "Seoul Sky – Lotte World Tower Ticket\n\n1–2 Hours\nObservation Deck • City Views • Photo Spots", badgeText: "Top Rated", priceTagText: "From ₹1,636" },
};

// ─────────────────────────────────────────────────────────────
// HOTEL OVERRIDES (merged on top of seed data)
// ─────────────────────────────────────────────────────────────

const HOTEL_DEFAULTS = {
  partner: "Klook",
  liveTagText: "LIVE NOW",
  offerText: "",
  primaryCta: "View Deal",
  secondaryCta: "Plan My Stay",
};

const HOTEL_OVERRIDES = {
  79: { countryCity: "Maldives", displayTitle: "Dusit Thani Maldives", description: "Dusit Thani Maldives\nMudhdhoo Island, Maldives\n\nLuxury Resort • Beach & Overwater Villas\nBreakfast Included • Free Cancellation", badgeText: "Luxury Escape", priceTagText: "From ₹80,949", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236044&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F243391%3F" },
  81: { countryCity: "Maldives", displayTitle: "Adaaran Club Rannalhi", description: "Adaaran Club Rannalhi\n\nBeach Resort • Water Villas\nAll Inclusive • Snorkelling", badgeText: "Hot Selling", priceTagText: "From ₹36,400", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236046&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F61435%3F" },
  82: { countryCity: "Maldives", displayTitle: "Machchafushi Island Resort & Spa", description: "Machchafushi Island Resort & Spa\nCentara Collection, Maldives\n\nLuxury Resort • Overwater Villas\nAll Inclusive • Spa Experience", badgeText: "Premium Honeymoon", priceTagText: "From ₹45,500", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236047&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F504477%3F" },
  83: { countryCity: "Maldives", displayTitle: "The Standard, Maldives", description: "The Standard, Maldives\nHuruvalhi Island\n\nLagoon Villas • Private Pool\nWater Parks • Trendy Luxury Stay", badgeText: "Couple Favourite", priceTagText: "From ₹33,265", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236049&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F238328%3F" },
  84: { countryCity: "Maldives", displayTitle: "Grand Park Kodhipparu Maldives", description: "Grand Park Kodhipparu Maldives\n\nOverwater & Beach Villas\nPrivate Pool • Spa & Lagoon Views", badgeText: "Luxury Island Escape", priceTagText: "From ₹57,303", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236050&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F584222%3F" },
  85: { countryCity: "Bali", displayTitle: "Adiwana Unagi Suites Ubud", description: "Adiwana Unagi Suites Ubud\nUbud, Bali\n\nBoutique Resort • Jungle Views\nPrivate Pool Suites • Peaceful Retreat", badgeText: "Boutique Stay", priceTagText: "From ₹10,899", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236052&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F583849%3F" },
  86: { countryCity: "Bali", displayTitle: "Poppies Bali", description: "Poppies Bali\nKuta, Bali\n\nBoutique Stay • Garden Villas\nCentral Location • Traditional Balinese Style", badgeText: "Great Value", priceTagText: "From ₹8,600", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236053&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F390934%3F" },
  87: { countryCity: "Bali", displayTitle: "Casa Pohon Ubud", description: "Casa Pohon Ubud\nUbud, Bali\n\nBoutique Stay • Jungle Setting\nPrivate Villas • Peaceful Retreat", badgeText: "Great Value", priceTagText: "From ₹18,466", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236054&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F952445%3F" },
  88: { countryCity: "Bali", displayTitle: "Aksari Luxury Resort & Spa by Ini Vie Hospitality", description: "Aksari Luxury Resort & Spa by Ini Vie Hospitality\nUbud, Bali\n\nLuxury Resort • Private Pool Villas\nFlower Bath • Jungle Views", badgeText: "Couple Favourite", priceTagText: "From ₹14,039", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236056&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F442672%3F" },
  89: { countryCity: "Bali", displayTitle: "Inara Alas Harum", description: "Inara Alas Harum\nUbud, Bali\n\nLuxury Resort • Rice Terrace Views\nInfinity Pool • Nature Experience", badgeText: "Trending", priceTagText: "From ₹8,725", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236057&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F1266750%3F" },
  90: { countryCity: "Bali", displayTitle: "Nandini Jungle by Hanging Gardens", description: "Nandini Jungle by Hanging Gardens\nUbud, Bali\n\nJungle Resort • Valley Views\nInfinity Pool • Spa Experience", badgeText: "Jungle Retreat", priceTagText: "From ₹11,712", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236058&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F322852%3F" },
  91: { countryCity: "Bali", displayTitle: "The Box Paradise Bungalow", description: "The Box Paradise Bungalow\nUbud, Bali\n\nBreakfast Included • Affordable Stay\nGarden Setting • Quiet Location", badgeText: "Budget Friendly", priceTagText: "From ₹1,799", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236059&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F88713%3F" },
  92: { countryCity: "Bali", displayTitle: "LaMeli Villas Ubud", description: "LaMeli Villas Ubud\nUbud, Bali\n\nBoutique Stay • Private Pool Villas\nRomantic Setup • Luxury Comfort", badgeText: "Premium Choice", priceTagText: "From ₹3,402", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236060&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F476156%3F" },
  93: { countryCity: "Bali", displayTitle: "Hotel Vila Lumbung", description: "Hotel Vila Lumbung\nSeminyak, Bali\n\nBreakfast Included • 2-level Swimming Pool\nGarden Villas • Central Location", badgeText: "Tropical Value", priceTagText: "From ₹3,904", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236061&k_site=https%3A%2F%2Fwww.klook.com%2Fen-GB%2Fhotels%2F256031%3F" },
  94: { countryCity: "Vietnam - Hanoi", displayTitle: "Hanoi Splendid Premium Hotel", description: "Hanoi Splendid Premium Hotel\nOld Quarter, Hanoi\n\nBreakfast Included • Easy Access\nSpa & Wellness Centre • Prime Location", badgeText: "Best Value", priceTagText: "From ₹7,195", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236062&k_site=https%3A%2F%2Fwww.klook.com%2Fen-GB%2Fhotels%2F1772744%3F" },
  95: { countryCity: "Vietnam - Hanoi", displayTitle: "Wyndham Sky Lake Resort & Villas", description: "Wyndham Sky Lake Resort & Villas\nHanoi, Vietnam\n\nBreakfast Included • Lake & Golf Views\nLuxury Villas • Free Cancellation", badgeText: "Limited Best Values", priceTagText: "From ₹8,013", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236063&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F243246%3F" },
  96: { countryCity: "Vietnam - Da Nang", displayTitle: "Santorin Hoi An Villa", description: "Santorin Hoi An Villa\nHoi An, Vietnam\n\nBreakfast Included • Heritage Style\nQuiet Location • No Prepayment Needed", badgeText: "Great Value", priceTagText: "From ₹5,072", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236064&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F13301%3F" },
  97: { countryCity: "Australia - Sydney", displayTitle: "The Lord Nelson Brewery Hotel", description: "The Lord Nelson Brewery Hotel\nSydney, Australia\n\nBreakfast Included • Historic Pub Hotel\nUnique Stay • No Prepayment Needed", badgeText: "Budget Pick", priceTagText: "From ₹15,281", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236065&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F532075%3F" },
  98: { countryCity: "Azerbaijan - Baku", displayTitle: "Holiday Inn Baku by IHG", description: "Holiday Inn Baku by IHG\nBaku, Azerbaijan\n\nBreakfast Included • City Views\nSpa • Pets Allowed", badgeText: "Premium City Stay", priceTagText: "From ₹10,307", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236066&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F54027%3F" },
  99: { countryCity: "Dubai", displayTitle: "Staybridge Suites by IHG", description: "Staybridge Suites by IHG\nDubai Financial Centre\n\nBreakfast Included • Suites Rooms • Kitchen • Long Stay\nCity Views • Prime Location", badgeText: "Great Value", priceTagText: "From ₹6,763", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236067&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F680230%3F" },
  101: { countryCity: "Georgia - Tbilisi", displayTitle: "Jazz Hotel", description: "Jazz Hotel\n\nBreakfast Included • Comfortable Rooms\nScenic View • Reschdule Flexibility", badgeText: "Budget Friendly", priceTagText: "From ₹3,395", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236071&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F213306%3F" },
  102: { countryCity: "Japan - Tokyo", displayTitle: "Sotetsu Fresa Inn", description: "Sotetsu Fresa Inn\nTokyo, Japan\n\nBreakfast Included • Compact Rooms\nMetro Access • Central Location", badgeText: "Value Pick", priceTagText: "From ₹9,924", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236072&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F741269%3F" },
  103: { countryCity: "Kazakhstan - Almaty", displayTitle: "Holiday Inn Almaty", description: "Holiday Inn Almaty\nAlmaty, Kazakhstan\n\nBreakfast Included • Mountain Views\nCentral Location • Comfortable Stay", badgeText: "Best Value", priceTagText: "From ₹10,315", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236074&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F70016%3F" },
  104: { countryCity: "Malaysia - Kuala Lumpur", displayTitle: "Neu Suites by Moonlight", description: "Neu Suites by Moonlight\nKuala Lumpur, Malaysia\n\nSuites • City Views\nSpacious Rooms • Swimming Pool", badgeText: "Great Deal", priceTagText: "From ₹2,089", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236076&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F1325806%3F" },
  105: { countryCity: "Singapore", displayTitle: "A Hotel Bugis", description: "A Hotel Bugis\nSingapore\n\nBudget Friendly • Compact Rooms\nGarden • Near MRT", badgeText: "Budget City Stay", priceTagText: "From ₹6,959", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236077&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F1712067%3F" },
  106: { countryCity: "Sri Lanka - Colombo", displayTitle: "Cinnamon Lakeside", description: "Cinnamon Lakeside\nColombo, Sri Lanka\n\nBreakfast Included • Lake Views\nPremium Dining • Free Cancellation", badgeText: "Luxury Stay", priceTagText: "From ₹6,758", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236078&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F248852%3F" },
  107: { countryCity: "Thailand - Pattaya", displayTitle: "LK Emerald Beach", description: "LK Emerald Beach\nPattaya, Thailand\n\nBreakfast Included • Beach Access\nRelaxed Stay • Scenic Views", badgeText: "Value Stay", priceTagText: "From ₹6,686", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236082&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F148484%3F" },
  108: { countryCity: "Thailand - Pattaya", displayTitle: "Bay Beach Resort", description: "Bay Beach Resort\nPattaya, Thailand\n\nBreakfast Included • Sea Views • Value Stay", badgeText: "Budget Friendly", priceTagText: "From ₹4,724", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236083&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F577844%3F" },
  109: { countryCity: "Thailand - Pattaya", displayTitle: "April Suites", description: "April Suites\nPattaya, Thailand\n\nModern Rooms\nCity Centre • Balcony View", badgeText: "Smart Budget Stay", priceTagText: "From ₹3,494", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236084&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F374770%3F" },
  110: { countryCity: "Thailand - Bangkok", displayTitle: "Bangkok City Rama 9 Hotel", description: "Bangkok City Rama 9 Hotel\nBangkok, Thailand\n\nCity View • Budget Stay\nGood Connectivity • Free Cancellation", badgeText: "Best Deal", priceTagText: "From ₹4,357", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236086&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F2169327%3F" },
  111: { countryCity: "Thailand - Bangkok", displayTitle: "Picnic Hotel", description: "Picnic Hotel\nBangkok, Thailand\n\nGarden Views • Near Markets\nComfortable Stay • Budget Friendly", badgeText: "Great Value", priceTagText: "From ₹3,231", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236087&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F279504%3F" },
  112: { countryCity: "Thailand - Bangkok", displayTitle: "Ramada by Wyndham Sukhumvit 87", description: "Ramada by Wyndham Sukhumvit 87\nBangkok, Thailand\n\nBreakfast Included • Modern Rooms\nNo Advance Needed • Prime Location", badgeText: "Premium City Stay", priceTagText: "From ₹5,222", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236088&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F864248%3F" },
  113: { countryCity: "Thailand - Krabi", displayTitle: "GLOW Ao Nang", description: "GLOW Ao Nang\nKrabi, Thailand\n\nBreakfast Included • Near Beach\nPool Access • Relaxed Atmosphere", badgeText: "Value Deal", priceTagText: "From ₹2,753", link: "https://affiliate.klook.com/redirect?aid=112088&aff_adid=1236089&k_site=https%3A%2F%2Fwww.klook.com%2Fhotels%2F436892%3F" },
};

// IDs to exclude from the final list (original excludes 80 and 100)
const EXCLUDED_IDS = new Set([80, 100]);

// ─────────────────────────────────────────────────────────────
// DEAL NORMALIZER
// Normalises any raw deal object into a consistent shape.
// ─────────────────────────────────────────────────────────────

/**
 * Normalise a raw deal object into the canonical deal shape.
 * @param {Object} raw
 * @returns {Object}
 */
export function normalizeDeal(raw = {}) {
  const id = String(raw.id ?? "").trim() || `custom-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const title = String(raw.title || "").trim() || "New Deal";
  const category = String(raw.category || "").trim() || "General Deals";
  const displayTitle = String(raw.displayTitle || "").trim() || title;
  const displayDescription = String(raw.displayDescription || "").trim();
  const description = String(raw.description || "").trim() || displayDescription || "";
  const isInternational =
    category !== "Indian Escapes Deals" &&
    category !== "Attractions" &&
    category !== "Hotels" &&
    category !== "Flights";
  const defaultWhatsAppMessage = buildDefaultWhatsAppMessage(displayTitle, category, isInternational);
  const whatsAppLink = String(raw.whatsAppLink || raw.whatsappLink || "").trim();

  return {
    id,
    category,
    countryCity: String(raw.countryCity || "").trim(),
    title,
    partner: String(raw.partner || "").trim(),
    airlinesPlatform: String(raw.airlinesPlatform || "").trim(),
    image: String(raw.image || "").trim(),
    imageFileName: String(raw.imageFileName || "").trim(),
    coupon: String(raw.coupon || "").trim() || "TRWDEAL",
    discount: String(raw.discount || "").trim(),
    link: String(raw.link || "").trim() || "#",
    sourceLink: String(raw.sourceLink || "").trim(),
    displayTitle,
    displayDescription: displayDescription || description,
    description,
    cta: String(raw.cta || "").trim(),
    badgeText: String(raw.badgeText || "").trim(),
    liveTagText: String(raw.liveTagText || "").trim(),
    offerText: String(raw.offerText || "").trim(),
    priceTagText: String(raw.priceTagText || "").trim(),
    validUntil: String(raw.validUntil || "").trim(),
    audienceText: String(raw.audienceText || "").trim(),
    primaryCta: String(raw.primaryCta || "").trim(),
    secondaryCta: String(raw.secondaryCta || "").trim(),
    whatsAppNumber: String(raw.whatsAppNumber || extractWhatsAppNumber(whatsAppLink, WHATSAPP_NUMBER)).trim() || WHATSAPP_NUMBER,
    whatsAppMessage: String(raw.whatsAppMessage || extractWhatsAppMessage(whatsAppLink, defaultWhatsAppMessage)).trim() || defaultWhatsAppMessage,
    whatsAppLink: whatsAppLink || buildWhatsAppUrl(displayTitle, category, isInternational),
  };
}

// ─────────────────────────────────────────────────────────────
// BUILD THE BASE SEED DEALS (with overrides applied)
// ─────────────────────────────────────────────────────────────

/** The complete set of IDs present in the seed data. */
const SEED_IDS = new Set(RAW_SEED_DEALS.map((d) => String(d.id)));

/**
 * Returns the canonical seed deals array with attraction / hotel overrides
 * applied, and the excluded IDs removed.
 */
function buildSeedDeals() {
  return RAW_SEED_DEALS.map((raw) => {
    const id = Number(raw.id);
    if (raw.category === "Attractions" && ATTRACTION_OVERRIDES[id]) {
      return normalizeDeal({
        ...raw,
        ...ATTRACTION_DEFAULTS,
        ...ATTRACTION_OVERRIDES[id],
        id: raw.id,
      });
    }
    if (raw.category === "Hotels" && HOTEL_OVERRIDES[id]) {
      return normalizeDeal({
        ...raw,
        ...HOTEL_DEFAULTS,
        ...HOTEL_OVERRIDES[id],
        id: raw.id,
      });
    }
    // Flight: rename secondaryCta
    if (raw.secondaryCta === "Talk to Travel Expert") {
      return normalizeDeal({ ...raw, secondaryCta: "Talk to Expert", liveTagText: "LIVE NOW" });
    }
    return normalizeDeal(raw);
  }).filter((d) => !EXCLUDED_IDS.has(Number(d.id)));
}

const SEED_DEALS = buildSeedDeals();

// ─────────────────────────────────────────────────────────────
// LOCAL STORAGE HELPERS
// ─────────────────────────────────────────────────────────────

const isBrowser = typeof window !== "undefined";

function readStorage(key) {
  if (!isBrowser) return [];
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeStorage(key, value) {
  if (isBrowser) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
}

function dispatchUpdate() {
  if (isBrowser) {
    window.dispatchEvent(new CustomEvent(SUPER_DEALS_UPDATED_EVENT));
  }
}

// Custom deals (not in seed data)
function getCustomDeals() {
  return readStorage(STORAGE_KEYS.CUSTOM).map(normalizeDeal).filter((d) => !SEED_IDS.has(d.id));
}
function saveCustomDeals(deals) { writeStorage(STORAGE_KEYS.CUSTOM, deals); }

// Seed overrides (modifications to existing seed deals)
function getSeedOverrides() {
  return readStorage(STORAGE_KEYS.SEED_OVERRIDES).map(normalizeDeal).filter((d) => SEED_IDS.has(d.id));
}
function saveSeedOverrides(overrides) { writeStorage(STORAGE_KEYS.SEED_OVERRIDES, overrides); }

// Deleted seed IDs
function getDeletedSeedIds() {
  return readStorage(STORAGE_KEYS.DELETED_IDS).map(String).filter((id) => SEED_IDS.has(id));
}
function saveDeletedSeedIds(ids) { writeStorage(STORAGE_KEYS.DELETED_IDS, ids); }

// ─────────────────────────────────────────────────────────────
// REMOTE SYNC HELPERS
// ─────────────────────────────────────────────────────────────

function getSyncUrls() {
  if (!isBrowser) return [];
  const baseUrl = typeof import.meta !== "undefined" ? (import.meta.env.BASE_URL || "/") : "/";
  const normalizedBase = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  const custom = [
    `${normalizedBase}live-data-sync.php`,
    ...(String(window.TRW_LIVE_DATA_SYNC_URLS || "")).split(","),
    ...(String(window.TRW_LIVE_DATA_SYNC_URL || "")).split(","),
    ...(String(window.TRW_SUPER_DEALS_SYNC_URLS || "")).split(","),
    ...(String(window.TRW_SUPER_DEALS_SYNC_URL || "")).split(","),
    ...(String(window.TRW_SYNC_URL || "")).split(","),
  ].map((u) => u.trim()).filter(Boolean);
  const defaults = [
    "/wp-json/trw/v1/live-data",
    "/?rest_route=/trw/v1/live-data",
    "/wp-json/trw/v1/super-deals",
    "/?rest_route=/trw/v1/super-deals",
  ];
  return [...new Set([...custom, ...defaults])];
}

function getSyncHeaders() {
  const headers = { "Content-Type": "application/json" };
  if (!isBrowser) return headers;
  const nonce = String(window.TRW_SYNC_NONCE || window.wpApiSettings?.nonce || "").trim();
  if (nonce) headers["X-WP-Nonce"] = nonce;
  try {
    const token = String(window.TRW_SYNC_TOKEN || window.localStorage.getItem("trw-sync-token") || "").trim();
    if (token) headers["X-TRW-Sync-Token"] = token;
  } catch { /* ignored */ }
  return headers;
}

function buildSyncPayload(url) {
  const payload = {
    customDeals: getCustomDeals(),
    seedOverrides: getSeedOverrides(),
    deletedSeedIds: getDeletedSeedIds(),
  };
  return url.includes("/super-deals") ? payload : { superDeals: payload };
}

function parseRemotePayload(data) {
  const outer = data?.data ?? data;
  const inner = outer?.superDeals ?? outer;
  return {
    customDeals: Array.isArray(inner?.customDeals)
      ? inner.customDeals.map(normalizeDeal).filter((d) => !SEED_IDS.has(d.id))
      : [],
    seedOverrides: Array.isArray(inner?.seedOverrides)
      ? inner.seedOverrides.map(normalizeDeal).filter((d) => SEED_IDS.has(d.id))
      : [],
    deletedSeedIds: Array.isArray(inner?.deletedSeedIds)
      ? inner.deletedSeedIds.map(String).filter((id) => SEED_IDS.has(id))
      : [],
  };
}

let _hydrated = false;
let _saving = false;
let _pendingSave = false;
let _pollingStarted = false;

/** Hydrate local storage from the remote WP REST endpoint (once). */
export async function hydrateFromRemote(force = false) {
  if (!isBrowser || (_hydrated && !force)) return;
  _hydrated = true;
  const urls = getSyncUrls();
  for (const url of urls) {
    try {
      const res = await fetch(url, { method: "GET", credentials: "same-origin", cache: "no-store" });
      if (!res.ok) continue;
      const json = await res.json();
      const parsed = parseRemotePayload(json);
      saveCustomDeals(parsed.customDeals);
      saveSeedOverrides(parsed.seedOverrides);
      saveDeletedSeedIds(parsed.deletedSeedIds);
      dispatchUpdate();
      return;
    } catch { /* try next */ }
  }
}

export function startRemotePolling() {
  if (!isBrowser || _pollingStarted) return;
  _pollingStarted = true;
  window.setInterval(() => {
    hydrateFromRemote(true);
  }, 10000);
}

/** Push local storage to the remote WP REST endpoint. */
export async function saveToRemote() {
  if (!isBrowser) return false;
  const urls = getSyncUrls();
  if (!urls.length) return false;
  if (_saving) { _pendingSave = true; return false; }
  _saving = true;
  _pendingSave = false;
  try {
    for (const url of urls) {
      try {
        const res = await fetch(url, {
          method: "POST",
          credentials: "same-origin",
          headers: getSyncHeaders(),
          body: JSON.stringify(buildSyncPayload(url)),
        });
        if (!res.ok) continue;
        return true;
      } catch { /* try next */ }
    }
    return false;
  } finally {
    _saving = false;
    if (_pendingSave) saveToRemote();
  }
}

// ─────────────────────────────────────────────────────────────
// PUBLIC DEALS API
// ─────────────────────────────────────────────────────────────

/**
 * Returns the full deal list, merging seed data with stored overrides.
 * @param {{ includeStoredOverrides?: boolean, includeCustomDeals?: boolean, hydrateRemote?: boolean }} options
 */
export function getDeals({ includeStoredOverrides = true, includeCustomDeals = true, hydrateRemote = true } = {}) {
  if (hydrateRemote && includeStoredOverrides) {
    hydrateFromRemote();
    startRemotePolling();
  }

  if (!includeStoredOverrides) {
    return includeCustomDeals ? [...SEED_DEALS, ...getCustomDeals()] : [...SEED_DEALS];
  }

  const overridesMap = new Map(getSeedOverrides().map((d) => [d.id, d]));
  const deletedIds = new Set(getDeletedSeedIds());

  const seeded = SEED_DEALS.map((d) => {
    if (!overridesMap.has(d.id)) return d;
    const override = overridesMap.get(d.id);
    const isAttractionOrHotel = ["Attractions", "Hotels"].includes(d.category);
    const protectedFields = isAttractionOrHotel
      ? {
        title: d.title, countryCity: d.countryCity, image: d.image, imageFileName: d.imageFileName,
        displayTitle: d.displayTitle, displayDescription: d.displayDescription, description: d.description,
        badgeText: d.badgeText, liveTagText: d.liveTagText, offerText: d.offerText,
        priceTagText: d.priceTagText, validUntil: d.validUntil, audienceText: d.audienceText,
        primaryCta: d.primaryCta, secondaryCta: d.secondaryCta, cta: d.cta, partner: d.partner, link: d.link,
      }
      : {};
    return normalizeDeal({ ...d, ...override, id: d.id, ...protectedFields });
  }).filter((d) => !deletedIds.has(d.id));

  return includeCustomDeals ? [...seeded, ...getCustomDeals()] : seeded;
}

/** Returns only the raw seed deals (no overrides). */
export function getSeedDealsRaw() {
  return SEED_DEALS.map(normalizeDeal);
}

/** Add a new custom deal (not in seed data). */
export function addCustomDeal(raw) {
  const deal = normalizeDeal(raw);
  const existing = getCustomDeals();
  saveCustomDeals([...existing, deal]);
  dispatchUpdate();
  saveToRemote();
  return getDeals();
}

/** Update (or create) any deal by ID. Routes to seedOverrides or customDeals. */
export function updateDeal(id, updates) {
  const strId = String(id);
  if (!SEED_IDS.has(strId)) {
    // custom deal
    const existing = getCustomDeals();
    const found = existing.find((d) => d.id === strId);
    const updated = found
      ? existing.map((d) => (d.id === strId ? normalizeDeal({ ...d, ...updates, id: strId }) : d))
      : [...existing, normalizeDeal({ ...updates, id: strId })];
    saveCustomDeals(updated);
  } else {
    // seed deal override
    const existing = getSeedOverrides();
    const found = existing.find((d) => d.id === strId);
    const normalized = normalizeDeal({ ...updates, id: strId });
    const updated = found
      ? existing.map((d) => (d.id === strId ? normalized : d))
      : [...existing, normalized];
    saveSeedOverrides(updated);
    saveDeletedSeedIds(getDeletedSeedIds().filter((i) => i !== strId));
  }
  dispatchUpdate();
  saveToRemote();
  return getDeals();
}

/** Delete a deal by ID. Seed deals are soft-deleted; custom deals are removed. */
export function deleteDeal(id) {
  const strId = String(id);
  if (!SEED_IDS.has(strId)) {
    saveCustomDeals(getCustomDeals().filter((d) => d.id !== strId));
  } else {
    saveDeletedSeedIds([...new Set([...getDeletedSeedIds(), strId])]);
    saveSeedOverrides(getSeedOverrides().filter((d) => d.id !== strId));
  }
  dispatchUpdate();
  saveToRemote();
  return getDeals();
}

// ─────────────────────────────────────────────────────────────
// DEAL CARD COMPONENT
// ─────────────────────────────────────────────────────────────

/**
 * Small hash helper: deterministically maps a string to a number in [base, base + mod).
 */
function hashRange(str, base, mod) {
  const s = String(str || "deal");
  let v = 0;
  for (let i = 0; i < s.length; i++) v = ((v * 31 + s.charCodeAt(i)) >>> 0);
  return base + (v % mod);
}

/**
 * DealCard – renders a single travel deal.
 *
 * Props:
 *   deal     {Object}   – normalised deal object
 *   openPopup {Function} – called with the deal when the secondary CTA is clicked
 */
function DealCard({ deal, darkMode = false, openPopup }) {
  const isFlights = deal.category === "Flights";
  const isAttractions = deal.category === "Attractions";
  const isHotels = deal.category === "Hotels";
  const isPackage = !isFlights && !isAttractions && !isHotels;

  const displayTitle = deal.displayTitle || deal.title;

  // ── Description cleaning ───────────────────────────────────
  const normalize = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  const keywords = (s) => normalize(s).split(" ").filter((w) => !["a", "an", "and", "at", "for", "from", "in", "of", "on", "the", "to", "with"].includes(w));
  const normTitle = normalize(displayTitle);
  const kwTitle = keywords(displayTitle);

  const rawDesc = isAttractions
    ? deal.description || deal.countryCity || deal.displayDescription || deal.category || ""
    : deal.description || deal.displayDescription || deal.countryCity || deal.category || "";

  const cleanedDesc = (isPackage ? rawDesc.replace(/\s+\.\s+/g, " • ") : rawDesc)
    .replace(/valid till:.*$/gim, "")
    .replace(/\d+\+?.*searched today.*$/gim, "")
    .split("\n").map((l) => l.replace(/\s{2,}/g, " ").trim()).join("\n").trim();

  const descLines = cleanedDesc.split("\n").map((l) => l.trim()).filter(Boolean);

  const isDuplicate = (line, idx) => {
    const normLine = normalize(line);
    if (!normLine || !normTitle) return false;
    const kwLine = keywords(line);
    const hasStructure = /[•|]/.test(line) || /\d/.test(line) || /includes?:/i.test(line);
    const sharedKw = kwLine.filter((w, i) => kwLine.indexOf(w) === i && kwTitle.includes(w)).length;
    const uniqueKw = kwLine.filter((w) => !kwTitle.includes(w));
    const isMostlyTitle = !!(kwLine.length && kwTitle.length && sharedKw >= 2 && uniqueKw.length <= 1 && (sharedKw / kwLine.length >= 0.75 || sharedKw / kwTitle.length >= 0.75));
    if (hasStructure) return false;
    if (normLine === normTitle || normLine.startsWith(normTitle) || normTitle.startsWith(normLine) || normLine.includes(normTitle) || isMostlyTitle) {
      return idx === 0 ? true : isAttractions;
    }
    return false;
  };

  const filteredLines = descLines.filter((l, i) => !isDuplicate(l, i));
  const [firstLine = "", ...restLines] = filteredLines;
  const restDesc = restLines.join("\n");

  // Attractions: all lines shown together
  const attrLines = isAttractions ? filteredLines : [];
  const attrFirst = attrLines[0] || "";
  const attrRest = isAttractions ? attrLines.slice(1).join("\n") : "";

  // Flight: parse structured lines
  const rawFlightLines = cleanedDesc.split("\n").map((l) => l.trim()).filter(Boolean);
  const flightTitle = rawFlightLines[0] || displayTitle;
  const flightLine2 = rawFlightLines[1] || "";
  const flightLine3 = rawFlightLines[2] || "";
  const flightLine4 = rawFlightLines[3] || "";

  // ── CTA & links ───────────────────────────────────────────
  const isDomesticIndia = isFlights && (
    String(deal.countryCity || "").trim().toLowerCase() === "india" ||
    /domestic|all india/i.test([deal.displayTitle, deal.title, deal.description, deal.displayDescription].filter(Boolean).join(" "))
  );

  const whatsAppUrl = deal.whatsAppLink || buildWhatsAppUrl(
    displayTitle,
    deal.category,
    !isDomesticIndia,
    deal.whatsAppNumber,
    deal.whatsAppMessage
  );
  const dealUrl = deal.link || whatsAppUrl;

  const offerText = (isFlights
    ? deal.offerText || deal.description || deal.displayDescription || `FLAT ${deal.discount || "25%"} OFF`
    : deal.priceTagText || deal.offerText || ""
  ).replace(/Valid till:.*$/i, "").trim();

  const badgeText = deal.badgeText || "LIMITED TIME";
  const liveTag = deal.liveTagText || "LIVE NOW";

  const validUntil = deal.validUntil || (() => {
    const m = (deal.displayDescription || deal.description || "").match(/Valid till:\s*([^.|]+)/i);
    return m ? m[1].trim() : "15th July";
  })();

  const idKey = [deal.displayTitle, deal.title, deal.countryCity, deal.priceTagText].filter(Boolean).join("|");
  const idKeyFull = [deal.displayTitle, deal.title, deal.countryCity, deal.priceTagText, deal.link].filter(Boolean).join("|");

  const audienceLabel = deal.category === "Attractions" && (!deal.audienceText || /^\d+\+\s*customer(s)?$/i.test(String(deal.audienceText).trim()))
    ? `${hashRange(idKey, 101, 99)}+ Customer`
    : deal.audienceText || "100+ Customer";
  const audienceText = audienceLabel.replace(/\bbooked\b/g, "Booked");

  const metaLabel = isHotels ? "Location" : "Valid Till";
  const metaValue = isHotels ? (deal.countryCity || "Hotel Deal") : validUntil;
  const metaRight = isHotels ? `${hashRange(idKeyFull, 120, 120)}+ people searched today` : audienceText;

  const primaryCta = deal.primaryCta || "Today's Deal";
  const secondaryCta = deal.secondaryCta || deal.cta || "Check Out";

  const handlePrimaryClick = () => window.open(dealUrl, "_self");
  const handleWhatsAppClick = () => window.open(whatsAppUrl, "_blank", "noopener,noreferrer");

  const bookmarkPost = {
    ...makeBookmarkPost({
      link: dealUrl,
      title: displayTitle,
      excerpt: deal.displayDescription || deal.description,
      imageSrc: deal.image,
      imageAlt: displayTitle,
    }),
    __bookmarkId: `superdeal-${String(deal.id ?? (idKeyFull || displayTitle || dealUrl))}`,
    __bookmarkType: "superdeals",
    __bookmarkSuperDealCategory: deal.category,
  };

  return (
    <div
      className={`trw-deal-card group relative flex h-full w-full flex-col overflow-hidden rounded-[18px] p-[14px] transition-transform duration-300 sm:rounded-[22px] sm:p-[18px] ${darkMode ? "bg-[#1a1a1a]" : "bg-[#F8F9FA]"
        }`}
      data-category={deal.category}
      data-title={displayTitle}
      data-coupon={deal.coupon}
      data-discount={deal.discount}
    >
      {/* ── Image block ──────────────────────────────────────── */}
      <div className="relative z-[1] mb-4 min-h-[228px] shrink-0 overflow-hidden rounded-[20px] bg-white sm:mb-5 sm:min-h-[264px] sm:rounded-[24px]">
        <a href={dealUrl} target="_self" rel="noopener noreferrer" className="block h-full w-full text-inherit no-underline" aria-label={`Open ${displayTitle}`}>
          <img
            src={deal.image}
            alt={displayTitle}
            className="relative z-[1] block h-[228px] w-full rounded-[20px] object-cover sm:h-[264px] sm:rounded-[24px]"
            loading="lazy"
            decoding="async"
          />

          {/* Badge */}
          <div className="pointer-events-none absolute top-0 left-[14px] z-[4] inline-flex h-[28px] w-fit items-center justify-center bg-[#D02525] px-3 sm:left-[16px] sm:h-[30px] sm:px-3">
            <span className="flex leading-[1] text-[11px] font-[700] tracking-[1px] text-white sm:text-[12px]">
              {badgeText}
            </span>
          </div>

          {/* Price tag (flights) */}
          {deal.priceTagText && isFlights && (
            <div className="pointer-events-none absolute top-3 right-3 z-[5] inline-flex h-[28px] w-fit items-center justify-center rounded-full bg-white/95 px-3 text-[#111827] shadow-[0_10px_25px_rgba(0,0,0,0.18)] sm:top-4 sm:right-4 sm:h-[32px]">
              <span className="flex whitespace-nowrap leading-[1] text-[11px] font-[900] tracking-[0.02em] sm:text-[12px]">
                {deal.priceTagText}
              </span>
            </div>
          )}

          {/* Gradient overlay */}
          <div className="absolute inset-x-0 bottom-0 z-[2] h-[112px] rounded-b-[20px] bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.62)_52%,rgba(0,0,0,0.96)_100%)] sm:h-[128px] sm:rounded-b-[24px]" />

          {/* Live tag + offer text */}
          <div className="absolute inset-x-0 bottom-0 z-[3] rounded-b-[20px] px-4 pb-4 pt-10 text-white sm:rounded-b-[24px] sm:px-5">
            <p className="m-0 inline-flex items-center gap-2 text-[12px] font-[700] tracking-[0.04em] uppercase sm:text-[13px]">
              <span aria-hidden="true" className="inline-flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="h-[26px] w-[26px]" aria-hidden="true" fill="none">
                  <path d="M12 7V12L9.5 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              {liveTag}
            </p>
            {offerText && (
              <p className="mt-1 mb-0 max-w-[75%] text-[16px] leading-[1.15] font-[900] tracking-[0.01em] sm:text-[24px]">
                {offerText}
              </p>
            )}
          </div>
        </a>

        {/* Bookmark button (top-right) */}
        <BookmarkIconButton
          post={bookmarkPost}
          categoryLabel="Super Deals"
          categorySlug="super-deals"
          categoryLink="/super-deals"
          className="absolute top-[8px] right-[8px] z-20 shadow-md"
          size={44}
          iconSize={20}
        />

        {/* WhatsApp button */}
        <button
          type="button"
          onClick={handleWhatsAppClick}
          className="absolute right-4 bottom-4 z-[6] inline-flex h-14 w-14 cursor-pointer items-center justify-center rounded-full bg-[#25d366] text-white shadow-[0_12px_30px_rgba(0,0,0,0.35)] transition-transform duration-300 group-hover:scale-[1.04]"
          aria-label="Check out on WhatsApp"
        >
          <svg viewBox="0 0 192 192" className="h-8 w-8 shrink-0 fill-current" aria-hidden="true">
            <path d="m60.359 160.867 2.894-5.256a6.003 6.003 0 0 0-4.284-.581l1.39 5.837ZM22 170l-5.837-1.39a6.002 6.002 0 0 0 7.227 7.227L22 170Zm9.133-38.359 5.837 1.39a6.001 6.001 0 0 0-.581-4.284l-5.256 2.894ZM96 176c44.183 0 80-35.817 80-80h-12c0 37.555-30.445 68-68 68v12Zm-38.535-9.877C68.9 172.42 82.04 176 96 176v-12c-11.884 0-23.04-3.043-32.747-8.389l-5.788 10.512Zm-34.075 9.714 38.358-9.133-2.78-11.674-38.358 9.133 2.78 11.674Zm1.906-45.585-9.133 38.358 11.674 2.78 9.133-38.359-11.674-2.779ZM16 96c0 13.959 3.58 27.1 9.877 38.535l10.512-5.788C31.043 119.039 28 107.884 28 96H16Zm80-80c-44.183 0-80 35.817-80 80h12c0-37.555 30.445-68 68-68V16Zm80 80c0-44.183-35.817-80-80-80v12c37.555 0 68 30.445 68 68h12Z" />
            <path d="M103 130H76V96h27c9.389 0 17 7.611 17 17s-7.611 17-17 17Zm-2-34H76V62h25c9.389 0 17 7.611 17 17s-7.611 17-17 17Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="12" />
          </svg>
        </button>
      </div>

      {/* ── Card body ─────────────────────────────────────────── */}
      <div className="flex flex-1 flex-col gap-4">

        {/* Title + description */}
        {isFlights ? (
          <div className={`flex flex-col gap-[8px] ${darkMode ? "text-[#a0a0a0]" : "text-[#4b5563]"}`}>
            <h3 className={`m-0 text-[20px] leading-[1.15] font-bold tracking-[-0.02em] sm:text-[21px] ${darkMode ? "text-white" : "text-[#08080b]"}`}>{flightTitle}</h3>
            {flightLine2 && <p className={`m-0 text-[15px] leading-[1.45] font-[600] tracking-[-0.01em] sm:text-[16px] ${darkMode ? "text-[#a0a0a0]" : "text-[#4b5563]"}`}>{flightLine2}</p>}
            {flightLine3 && <p className={`m-0 text-[14px] leading-[1.45] font-[500] tracking-[-0.01em] sm:text-[15px] ${darkMode ? "text-[#a0a0a0]" : "text-[#4b5563]"}`}>{flightLine3}</p>}
            {flightLine4 && <p className={`m-0 text-[14px] leading-[1.45] font-[500] tracking-[-0.01em] sm:text-[15px] ${darkMode ? "text-[#a0a0a0]" : ""}`}>{flightLine4}</p>}
          </div>
        ) : (
          <>
            <h3 className={`m-0 text-[20px] leading-[1.15] font-bold tracking-[-0.02em] sm:text-[21px] ${darkMode ? "text-white" : "text-[#08080b]"} ${isAttractions ? "whitespace-normal" : "overflow-hidden whitespace-nowrap text-ellipsis"}`}>
              {displayTitle}
            </h3>
            <div className={`flex flex-col gap-[8px] ${darkMode ? "text-[#a0a0a0]" : "text-[#4b5563]"}`}>
              {firstLine && !isAttractions && (
                <p className={`m-0 text-[15px] leading-[1.45] font-[700] tracking-[-0.01em] sm:text-[16px] ${darkMode ? "text-[#a0a0a0]" : ""}`}>{firstLine}</p>
              )}
              {attrFirst && (
                <p className={`m-0 text-[15px] leading-[1.45] font-[700] tracking-[-0.01em] sm:text-[16px] ${darkMode ? "text-[#a0a0a0]" : "text-[#4b5563]"}`}>{attrFirst}</p>
              )}
              {(isAttractions ? attrRest : restDesc) && (
                <p className={`m-0 whitespace-pre-line text-[14px] leading-[1.45] font-[500] tracking-[-0.01em] sm:text-[15px] ${darkMode ? "text-[#a0a0a0]" : ""}`}>
                  {isAttractions ? attrRest : restDesc}
                </p>
              )}
              {!firstLine && !restDesc && !isAttractions && (
                <p className={`m-0 text-[15px] leading-[1.45] font-[500] tracking-[-0.01em] sm:text-[16px] ${darkMode ? "text-[#a0a0a0]" : ""}`}>{deal.category}</p>
              )}
            </div>
          </>
        )}

        {/* Meta row */}
        <div className={`mt-auto grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 border-t border-b py-4 ${darkMode ? "border-[#333]" : "border-[#e5e7eb]"
          }`}>
          <div className={`min-w-0 border-r pr-3 ${darkMode ? "border-[#333]" : "border-[#e5e7eb]"}`}>
            <p className={`m-0 text-[13px] leading-none ${darkMode ? "text-[#707070]" : "text-[#6b7280]"}`}>{metaLabel}</p>
            <p className={`mt-1 mb-0 text-[12px] font-[900] sm:text-[13px] ${isHotels ? "whitespace-normal leading-[1.25] tracking-normal" : "whitespace-nowrap leading-none tracking-[0.04em] uppercase"
              } ${darkMode ? "text-white" : "text-[#111827]"}`}>
              {metaValue}
            </p>
          </div>
          <div className="shrink-0 text-right text-[14px] font-[800] whitespace-nowrap text-[#D02525]">{metaRight}</div>
        </div>

        {/* CTA buttons */}
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <button
            type="button"
            onClick={handlePrimaryClick}
            className="group inline-flex min-h-[50px] w-full cursor-pointer items-center justify-center gap-2 rounded-[12px] border border-[#D02525] bg-[#D02525] px-[14px] py-0 text-center text-[20px] font-[700] text-white transition-colors duration-300 hover:border-black hover:bg-black"
          >
            {primaryCta}
            <ArrowIcon />
          </button>

          <button
            type="button"
            onClick={() => openPopup(deal)}
            className="group inline-flex min-h-[50px] w-full cursor-pointer items-center justify-center gap-2 rounded-[12px] border border-[#D02525] bg-[#D02525] px-[14px] py-0 text-center text-[20px] font-[700] text-white transition-colors duration-300 hover:border-black hover:bg-black"
            aria-label="Check out deal"
          >
            {secondaryCta}
            <ArrowIcon />
          </button>
        </div>

        <p className={`m-0 text-center text-[10px] leading-[1.4] ${darkMode ? "text-[#707070]" : "text-[#777]"}`}>
          Offers and Prices are finalized by our Partners. T&Cs apply.
        </p>
      </div>
    </div>
  );
}

/** Arrow icon reused across CTA buttons. */
function ArrowIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="h-5 w-5 shrink-0 transition-transform duration-300 group-hover:rotate-45"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7 17 17 7" />
      <path d="M9 7h8v8" />
    </svg>
  );
}

/** Memoised export of DealCard. */
export const MemoizedDealCard = memo(DealCard);
export { DealCard };

// ─────────────────────────────────────────────────────────────
// LEGACY NAMED EXPORTS (mirror original module exports)
// ─────────────────────────────────────────────────────────────

export const IMG_ANDAMAN_EXPORT = IMG_ANDAMAN;
export const IMG_KASHMIR_EXPORT = IMG_KASHMIR;
export const IMG_RAJASTHAN_EXPORT = IMG_RAJASTHAN;
export const IMG_KERALA_EXPORT = IMG_KERALA;
export const IMG_KARNATAKA_EXPORT = IMG_KARNATAKA;
export const IMG_DELHI_EXPORT = IMG_DELHI;
export const IMG_MEGHALAYA_EXPORT = IMG_MEGHALAYA;
export const IMG_BALI_EXPORT = IMG_BALI_DEST;
export const IMG_DUBAI_EXPORT = IMG_DUBAI_DEST;
export const IMG_THAILAND_EXPORT = IMG_THAILAND_DEST;
export const IMG_EUROPE_EXPORT = IMG_EUROPE_DEST;
export const IMG_GEORGIA_EXPORT = IMG_GEORGIA_DEST;
export const IMG_TURKEY_EXPORT = IMG_TURKEY_DEST;
